/* 全站客户端脚本（静态资源，immutable 长缓存，改动后需递增 layout.ts 的 JS_VER）
 * localStorage 契约集中在 store：tiku-done / tiku-wrong / tiku-fav 存 "/q/<slug>/" 路径数组，
 * tiku-wrongt 存 {"/q/<slug>/":最后一次答错/复习秒级时间戳}；tiku-wrongk 存 {"/q/<slug>/":已通过复习轮次 1|2}（缺省 0，三轮出师移出）；
 * tiku-stats 存 {"a":总作答,"c":答对}；tiku-days / tiku-dayok 存 {"YYYY-MM-DD":当日作答数 / 答对数}（126 天）；tiku-last 存 {p:题目路径,s:科目名}；tiku-note-off 存 "1" 表示已关闭顶栏提示；
 * sessionStorage tiku-daily-queue 存 {slugs:[...]}；tiku-mock 存 {slugs:[...],paper:试卷路径,start:毫秒,dur:秒,end:毫秒,ok:{slug:bool}}。
 * 坏值自愈：JSON 解析失败即清除该键并回退默认值。 */
(function () {
  'use strict';

  var store = {
    read: function (k, def) {
      try { return JSON.parse(localStorage.getItem(k) || def); }
      catch (_) { try { localStorage.removeItem(k); } catch (__) { /* noop */ } return JSON.parse(def); }
    },
    readList: function (k) { return store.read(k, '[]'); },
    write: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (_) { /* noop */ } }
  };
  var Q_PATH_RE = /^\/q\/([^/]+)\/?$/;
  function toSlug(p) { var m = Q_PATH_RE.exec(p); return m ? m[1] : null; }
  /* QA/自动化流量标记：任一非操作台页 ?qa=1 / ?qa=0 写入或清除 tiku-qa；Playwright/Lighthouse 自启浏览器 navigator.webdriver 自动命中。
   * 开启后 /api/attempt 与 /api/feedback 上报体带 qa:true，服务端不落库（docs/plan-r497） */
  (function () {
    var m = /[?&]qa=([01])(&|$)/.exec(location.search);
    if (!m) return;
    try { if (m[1] === '1') localStorage.setItem('tiku-qa', '1'); else localStorage.removeItem('tiku-qa'); } catch (_) { /* noop */ }
  })();
  function qaOn() {
    try { return navigator.webdriver === true || localStorage.getItem('tiku-qa') === '1'; } catch (_) { return navigator.webdriver === true; }
  }
  function postHeaders() {
    var h = { 'Content-Type': 'application/json' };
    if (qaOn()) h['x-qa-audit'] = '1';
    return h;
  }
  /* 非 2xx 写接口响应 → 以服务端 {error} 文案（如 429「操作太频繁」）拒绝；无 JSON 用 fallback。err.shown 标记可直出（网络异常的英文 message 不直出） */
  function rejectWith(r, fallback) {
    return r.json().catch(function () { return null; }).then(function (j) {
      var e = new Error((j && typeof j.error === 'string' && j.error) || fallback); e.shown = true; throw e;
    });
  }
  function shownMsg(e, fallback) { return e && e.shown && e.message ? e.message : fallback; }
  /* 会话键 = search + 可选 #x=<来源题 slug>（与 practice.js SKEY 同构） */
  var WS_URL_RE = /^\/practice\/(\?[\w=&%,.-]*(?:#x=[\w-]{1,80})?)$/;
  function readWs(query) {
    try { return JSON.parse(sessionStorage.getItem('tiku-ws:' + query) || 'null'); } catch (_) { return null; }
  }
  /* 续练候选：tiku-last.u 指向的操作台会话若已在本标签页交卷，则不再作为「继续练习」 */
  function lastWsHref(last) {
    if (!last || typeof last.u !== 'string') return null;
    var m = WS_URL_RE.exec(last.u); if (!m) return null;
    var s = readWs(m[1]);
    return s && s.submitted ? null : last.u;
  }
  /* 错题连刷乱序：防按位置/顺序记忆答案（Fisher-Yates，返回新数组） */
  function shuffleSlugs(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }
  var QTYPE = { single_choice: '单选题', multi_choice: '多选题', true_false: '判断题', material: '材料题' };
  /* 错题艾宾浩斯间隔（秒）：第 0/1/2 轮到期间隔 1/3/7 天，三轮答对出师 */
  var REVIEW_GAPS = [86400, 259200, 604800];
  /* 到期判定：距最后答错/复习 ≥ 当前轮次间隔，无时间戳的存量错题视为到期（wrongDue / recordAnswer / practice.js 同契约） */
  function reviewDue(t, stg) {
    return typeof t !== 'number' || Math.floor(Date.now() / 1000) - t >= REVIEW_GAPS[Math.max(0, Math.min(2, stg || 0))];
  }
  /* 薄弱考点阈值：已做 ≥3 且错题本口径正确率 <70% */
  var WEAK_MIN_DONE = 3; var WEAK_ACC = 0.7;
  /* 考点页「我的进度」卡首帧依据 tiku-kpcard[exam/subject/kp]=[mine,wrong,weak]（LRU 50）。
     initKpPageCard 按全考点数据写回三元精确值；题页有 #q-side-grid（主考点全部题序）时主考点同口径写三元，
     其余作答处只知本题结果，写 [1, wrong] 二元（薄弱沿用旧值，缺省不填，BOOT 退回本页估算） */
  var KPCARD_MAX = 50;
  var KP_HREF_RE = /^\/kaoshi\/([\w-]+)\/([\w-]+)\/kp\/([\w-]+)\/$/;
  function writeKpCard(key, val) {
    var all = store.read('tiku-kpcard', '{}');
    if (!all || typeof all !== 'object' || Array.isArray(all)) all = {};
    delete all[key];
    if (val) {
      var keys = Object.keys(all);
      while (keys.length >= KPCARD_MAX) delete all[keys.shift()];
      all[key] = val;
    }
    store.write('tiku-kpcard', all);
  }
  /* 题页 R531 侧栏：标题链接为主考点、#q-side-grid 为该考点全部题 slug；须在 tiku-done/tiku-wrong 写完后调用 */
  function qSideKpCard() {
    var side = document.getElementById('q-side'); if (!side) return null;
    var link = side.querySelector('a[href^="/kaoshi/"]');
    var cells = side.querySelectorAll('#q-side-grid a[data-q]');
    if (!link || cells.length < 2) return null;
    var doneSet = {}; var wrongSet = {};
    store.readList('tiku-done').forEach(function (p) { var s = toSlug(p); if (s) doneSet[s] = 1; });
    store.readList('tiku-wrong').forEach(function (p) { var s = toSlug(p); if (s) wrongSet[s] = 1; });
    var done = 0, ok = 0, wrong = 0;
    Array.prototype.forEach.call(cells, function (a) {
      var s = a.getAttribute('data-q');
      if (doneSet[s]) { done++; if (!wrongSet[s]) ok++; }
      if (wrongSet[s]) wrong++;
    });
    var weak = done >= WEAK_MIN_DONE && ok / done < WEAK_ACC;
    return { href: link.getAttribute('href'), val: [1, wrong > 0 ? 1 : 0, weak ? 1 : 0] };
  }
  function touchKpCard(hrefs, ok) {
    var all = store.read('tiku-kpcard', '{}');
    if (!all || typeof all !== 'object' || Array.isArray(all)) all = {};
    var exact = qSideKpCard();
    hrefs.forEach(function (h) {
      var m = KP_HREF_RE.exec(h || '');
      if (!m) return;
      var key = m[1] + '/' + m[2] + '/' + m[3];
      if (exact && h === exact.href) { writeKpCard(key, exact.val); return; }
      var old = all[key];
      var wrong = (Array.isArray(old) && old[1]) || !ok ? 1 : 0;
      writeKpCard(key, Array.isArray(old) && old.length > 2 ? [1, wrong, old[2]] : [1, wrong]);
    });
  }
  /* 智能练习直达（practice.js mode=smart 客户端选题），题数跟随科目页偏好 tiku-n */
  /* line=1：蓝图线（行测）按整卷口径跨科目选题，无蓝图的线服务端回落本科目池（首页弱项卡 / 掌握度入口；科目页「该科目智能练习」不带） */
  function smartPracticeHref(exam, subject) {
    var n = store.read('tiku-n', '10');
    if ([5, 10, 15, 20].indexOf(n) < 0) n = 10;
    return '/practice/?mode=smart&exam=' + encodeURIComponent(exam) + '&subject=' + encodeURIComponent(subject) + '&line=1&n=' + n;
  }
  function stars(d) { var f = Math.max(1, Math.min(5, d || 1)); return '★'.repeat(f) + '☆'.repeat(5 - f); }
  /* 上次作答 tiku-pick {slug: 'B'|'AC'}：只记计分作答，返回旧值（首答 ''），上限 1000 条删最早插入 */
  function rememberPick(slug, pick) {
    if (!slug || !pick) return '';
    var all = store.read('tiku-pick', '{}');
    if (!all || typeof all !== 'object' || Array.isArray(all)) all = {};
    var prev = /^[A-H]{1,8}$/.test(all[slug]) ? all[slug] : '';
    delete all[slug]; all[slug] = pick;
    var keys = Object.keys(all);
    while (keys.length > 1000) { delete all[keys.shift()]; }
    store.write('tiku-pick', all);
    return prev;
  }
  function prevPickNote(prev, pick, ok) {
    if (!prev) return '';
    return prev === pick ? (ok ? '' : ' · 上次也选 ' + prev) : ' · 上次选 ' + prev;
  }
  function localDay(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  /* 当前周键（UTC+8 ISO 周，YYYY-Www，与服务端 weekShanghai 同构） */
  function curWeekIso() {
    var d = new Date(Date.now() + 8 * 3600e3);
    var day = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - day);
    var y = d.getUTCFullYear();
    var week = Math.ceil(((d.getTime() - Date.UTC(y, 0, 1)) / 86400e3 + 1) / 7);
    return y + '-W' + String(week).padStart(2, '0');
  }
  /* 本周是否已交本线每周模考（tiku-hist 标题契约：{线名} · 每周模考（YYYY-Www）） */
  function weeklyMockDone(hist, planName) {
    var tag = '每周模考（' + curWeekIso() + '）';
    return hist.some(function (h) {
      return h && typeof h.s === 'string' && h.s.indexOf(tag) !== -1 && h.s.indexOf(planName + ' · ') === 0;
    });
  }
  /* 今日是否已交本线每日一练（tiku-hist 标题契约：每日一练 · YYYY-MM-DD …） */
  function dailyDoneToday(hist) {
    var tag = '每日一练 · ' + localDay(new Date());
    return hist.some(function (h) { return h && typeof h.s === 'string' && h.s.indexOf(tag) === 0; });
  }
  /* 备考计划「刷题量」入口：每日一练未交先去 /daily/（计入刷题量）；已交且未达标 → 本线随机补齐缺口，
     题数取 5/10/15/20 中首个 ≥ 缺口（与首页无计划态「补齐今日目标」同式，docs/plan-r585） */
  function planQuotaHref(examSlug, n, g, dailyDone) {
    var daily = '/daily/?exam=' + encodeURIComponent(examSlug);
    if (!dailyDone || n >= g || !/^[\w-]{1,40}$/.test(examSlug)) return daily;
    var fill = [5, 10, 15, 20].filter(function (k) { return k >= g - n; })[0] || 20;
    return '/practice/?mode=random&exam=' + encodeURIComponent(examSlug) + '&n=' + fill;
  }
  /* 备考计划达标态 CTA：本线随机再练 10 题（不再指向已交卷的每日一练，docs/plan-r586） */
  function planMoreHref(examSlug) {
    if (!/^[\w-]{1,40}$/.test(examSlug)) return '/daily/?exam=' + encodeURIComponent(examSlug);
    return '/practice/?mode=random&exam=' + encodeURIComponent(examSlug) + '&n=10';
  }

  /* ---------- 题目笔记（tiku-note：{slug:{t:文本,u:更新秒}}，本地优先） ---------- */
  var NOTE_KEY = 'tiku-note';
  function readNotes() { var n = store.read(NOTE_KEY, '{}'); return (n && typeof n === 'object' && !Array.isArray(n)) ? n : {}; }
  function capNotes(notes) {
    var keys = Object.keys(notes);
    if (keys.length > 200) {
      keys.sort(function (x, y) { return ((notes[x] || {}).u || 0) - ((notes[y] || {}).u || 0); });
      while (keys.length > 200) { delete notes[keys.shift()]; }
    }
    return notes;
  }
  function saveNote(slug, text) {
    var notes = readNotes();
    var t = String(text || '').slice(0, 1000).replace(/\s+$/, '');
    if (t) { notes[slug] = { t: t, u: Math.floor(Date.now() / 1000) }; } else { delete notes[slug]; }
    store.write(NOTE_KEY, capNotes(notes));
  }
  function bindNote(ta, msgEl, slug) {
    var cur = readNotes()[slug];
    if (cur && cur.t) { ta.value = cur.t; }
    var timer = null; var dirty = false;
    function flush() {
      if (!dirty) return;
      dirty = false; if (timer) { clearTimeout(timer); timer = null; }
      saveNote(slug, ta.value);
      if (msgEl) { msgEl.textContent = ta.value.replace(/\s+$/, '') ? '已保存 · 仅保存在本浏览器' : '已删除这条笔记'; }
    }
    ta.addEventListener('input', function () {
      dirty = true;
      if (msgEl) { msgEl.textContent = '输入中…'; }
      if (timer) { clearTimeout(timer); }
      timer = setTimeout(flush, 600);
    });
    ta.addEventListener('blur', flush);
  }

  /* ---------- 题目页（/q/:slug/） ---------- */
  function initQuiz() {
    var fs = document.getElementById('options'); if (!fs) return;
    var answer = fs.dataset.answer || ''; var multi = fs.dataset.multi === '1';
    var opts = Array.prototype.slice.call(fs.querySelectorAll('.js-opt'));
    var verdict = document.getElementById('verdict');
    var analysis = document.getElementById('analysis');
    var reveal = document.getElementById('reveal');
    var submitBtn = document.getElementById('submit-multi');
    var answered = false; var picked = []; var revealed = false;
    /* 逐题用时（对齐操作台 ws.qt 口径：只累计页面可见时段，切后台 / bfcache 离开不计；判分即止）。
       计分作答上报 ms（服务端 500ms–10min 有效域聚合为全站平均用时）并落 tiku-stats.u / tiku-mins（单题封顶 600 秒），
       与操作台交卷同键同口径，/my/「练习时长」与近 7 天时长柱由此覆盖题页作答 */
    var qtAcc = 0; var qtFrom = document.hidden ? 0 : Date.now();
    function qtStop() { if (qtFrom) { qtAcc += Date.now() - qtFrom; qtFrom = 0; } return qtAcc; }
    document.addEventListener('visibilitychange', function () {
      if (answered) return;
      if (document.hidden) qtStop(); else if (!qtFrom) qtFrom = Date.now();
    });
    function qtNote(ms) {
      if (ms < 500) return '';
      var s = Math.round(ms / 1000);
      return ' · 用时 ' + (s < 60 ? s + ' 秒' : Math.floor(s / 60) + ' 分 ' + (s % 60) + ' 秒');
    }
    var CHECK = '<svg class="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/></svg>';
    var CROSS = '<svg class="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/></svg>';
    function showAnalysis() {
      if (analysis) { analysis.hidden = false; }
      var rel = document.getElementById('related'); if (rel) { rel.hidden = false; }
    }
    function markOption(btn, state) {
      var badge = btn.querySelector('.js-opt-badge'); var mark = btn.querySelector('.js-opt-mark');
      btn.classList.remove('hover:border-brand-600/50', 'hover:bg-brand-50/40');
      if (state === 'correct') {
        btn.classList.remove('border-line', 'bg-white'); btn.classList.add('border-emerald-500', 'bg-emerald-50');
        badge.classList.remove('border', 'border-line', 'text-muted'); badge.classList.add('bg-emerald-700', 'text-white');
        mark.className = 'js-opt-mark mt-0.5 flex items-center gap-1 text-sm font-medium text-emerald-700';
        mark.innerHTML = CHECK + '正确答案'; btn.setAttribute('aria-label', '正确答案');
      } else if (state === 'wrong') {
        btn.classList.remove('border-line', 'bg-white'); btn.classList.add('border-red-400', 'bg-red-50');
        badge.classList.remove('border', 'border-line', 'text-muted'); badge.classList.add('bg-red-600', 'text-white');
        mark.className = 'js-opt-mark mt-0.5 flex items-center gap-1 text-sm font-medium text-red-700';
        mark.innerHTML = CROSS + '你的选择'; btn.setAttribute('aria-label', '你的错误选择');
      } else {
        btn.classList.add('opacity-60', 'pointer-events-none');
      }
    }
    /* 选项排除（与操作台 R594 同一手势契约）：长按 500 ms（位移 >10 px / 提前松手取消）、鼠标右键、Shift+字母；
       页内瞬时状态不落盘；判分 / 背题即清空；长按后紧随的 click 吞掉，已排除项点击 = 取消排除不作答 */
    var excl = ''; var lpFired = false; var lastPtr = 'mouse';
    function paintExcl(btn, on) {
      btn.dataset.excl = on ? '1' : '';
      btn.classList.toggle('qz-excl', on);
      var sr = btn.querySelector('.js-excl-sr');
      if (on && !sr) { sr = document.createElement('span'); sr.className = 'js-excl-sr sr-only'; sr.textContent = '（已排除）'; btn.appendChild(sr); }
      if (!on && sr) sr.remove();
    }
    function unpick(b) {
      var k = b.dataset.key; var i = picked.indexOf(k);
      if (i < 0) return;
      picked.splice(i, 1); b.setAttribute('aria-checked', 'false');
      b.classList.remove('border-brand-600', 'bg-brand-50', 'ring-1', 'ring-brand-600'); b.classList.add('border-line');
      if (submitBtn) { submitBtn.classList.toggle('hidden', picked.length === 0); submitBtn.classList.toggle('flex', picked.length > 0); }
    }
    function exclToggle(b) {
      if (answered) return;
      var k = b.dataset.key;
      var on = excl.indexOf(k) < 0;
      excl = on ? (excl + k).split('').sort().join('') : excl.replace(k, '');
      paintExcl(b, on);
      if (on) unpick(b);
    }
    function clearExcl() { excl = ''; opts.forEach(function (b) { paintExcl(b, false); }); }
    function wireExcl(b) {
      var tm = 0; var sx = 0; var sy = 0;
      function cancel() { if (tm) { clearTimeout(tm); tm = 0; } }
      b.addEventListener('pointerdown', function (e) {
        lastPtr = e.pointerType || 'mouse'; lpFired = false;
        if (e.button !== 0 || answered) return;
        sx = e.clientX; sy = e.clientY;
        cancel(); tm = setTimeout(function () { tm = 0; lpFired = true; exclToggle(b); }, 500);
      });
      b.addEventListener('pointermove', function (e) { if (tm && (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10)) cancel(); });
      b.addEventListener('pointerup', cancel); b.addEventListener('pointercancel', cancel); b.addEventListener('pointerleave', cancel);
      b.addEventListener('contextmenu', function (e) { if (answered) return; e.preventDefault(); if (lastPtr === 'mouse') exclToggle(b); });
    }
    function exclClick(b) {
      if (lpFired) { lpFired = false; return true; }
      if (b.dataset.excl === '1') { exclToggle(b); return true; }
      return false;
    }
    var prevPick = '';
    function finish(chosen) {
      clearExcl();
      answered = true;
      /* 作答即记本题所属考试线（搜索直达题页的用户回首页 / 底栏练习 / 模考页随之对齐）；只看不答不写，科目页则浏览即写 */
      var qx = qPageExam(); if (qx) store.write('tiku-exam', qx);
      var doneList = store.readList('tiku-done');
      if (doneList.indexOf(location.pathname) < 0) { doneList.push(location.pathname); store.write('tiku-done', doneList); }
      var chosenSet = chosen.slice().sort().join('');
      var answerSet = answer.split('').sort().join('');
      var ok = chosenSet === answerSet;
      var qms = qtStop();
      try {
        var mk = JSON.parse(sessionStorage.getItem('tiku-mock') || 'null');
        var mSlug = toSlug(location.pathname);
        if (mk && mk.slugs && mk.slugs.indexOf(mSlug) >= 0 && /[?&]from=mock(&|$)/.test(location.search)) {
          mk.ok = mk.ok || {}; mk.ok[mSlug] = ok && !revealed;
          sessionStorage.setItem('tiku-mock', JSON.stringify(mk));
        }
      } catch (_) { /* noop */ }
      if (!revealed) {
        /* 全站答题计数上报（匿名聚合，失败静默） */
        try {
          var abody = JSON.stringify({ slug: toSlug(location.pathname), ok: ok, picked: chosen, ms: qms > 0 ? qms : undefined, qa: qaOn() || undefined });
          if (!(navigator.sendBeacon && navigator.sendBeacon('/api/attempt', new Blob([abody], { type: 'application/json' })))) {
            fetch('/api/attempt', { method: 'POST', headers: postHeaders(), body: abody, keepalive: true }).catch(function () { /* noop */ });
          }
        } catch (_) { /* noop */ }
        var qsec = Math.min(Math.round(qms / 1000), 600);
        var st = store.read('tiku-stats', '{"a":0,"c":0}');
        st.a++; if (ok) st.c++;
        if (qsec > 0) st.u = (st.u || 0) + qsec;
        store.write('tiku-stats', st);
        prevPick = rememberPick(toSlug(location.pathname), chosenSet);
        /* 按日做题量（本地日期），保留 126 天：覆盖学习日历 12 周展示窗口 */
        var days = store.read('tiku-days', '{}');
        var dk = localDay(new Date());
        days[dk] = (days[dk] || 0) + 1;
        var dkeys = Object.keys(days).sort();
        while (dkeys.length > 126) { delete days[dkeys.shift()]; }
        store.write('tiku-days', days);
        var dok = store.read('tiku-dayok', '{}');
        dok[dk] = (dok[dk] || 0) + (ok ? 1 : 0);
        var okeys = Object.keys(dok).sort();
        while (okeys.length > 126) { delete dok[okeys.shift()]; }
        store.write('tiku-dayok', dok);
        if (qsec > 0) {
          var minsMap = store.read('tiku-mins', '{}');
          minsMap[dk] = (minsMap[dk] || 0) + qsec;
          var mkeys = Object.keys(minsMap).sort();
          while (mkeys.length > 126) { delete minsMap[mkeys.shift()]; }
          store.write('tiku-mins', minsMap);
        }
        var wrongList = store.readList('tiku-wrong');
        var wi = wrongList.indexOf(location.pathname);
        var wt = store.read('tiku-wrongt', '{}');
        var wk = store.read('tiku-wrongk', '{}');
        if (!ok) {
          if (wi < 0) wrongList.push(location.pathname);
          wt[location.pathname] = Math.floor(Date.now() / 1000);
          delete wk[location.pathname];
          var glw = store.readList('tiku-wronggl');
          var gliw = glw.indexOf(location.pathname);
          if (gliw >= 0) { glw.splice(gliw, 1); store.write('tiku-wronggl', glw); }
        } else if (wi >= 0 && reviewDue(wt[location.pathname], wk[location.pathname])) {
          /* 间隔复习：到期后答对才推进轮次（1/3/7 天），未到期答对不改时间戳与轮次；第三轮答对出师移出并归档 */
          var stg = wk[location.pathname] || 0;
          if (stg >= 2) {
            wrongList.splice(wi, 1);
            delete wt[location.pathname]; delete wk[location.pathname];
            store.write('tiku-wrongg', (store.read('tiku-wrongg', '0') || 0) + 1);
            var glg = store.readList('tiku-wronggl');
            if (glg.indexOf(location.pathname) < 0) {
              glg.push(location.pathname);
              if (glg.length > 200) glg.splice(0, glg.length - 200);
              store.write('tiku-wronggl', glg);
            }
          } else {
            wk[location.pathname] = stg + 1;
            wt[location.pathname] = Math.floor(Date.now() / 1000);
          }
        }
        store.write('tiku-wrong', wrongList);
        store.write('tiku-wrongt', wt);
        store.write('tiku-wrongk', wk);
        /* 错题次数：答错 +1，答对不清零（历史保留），超 500 条删计数最小者 */
        if (!ok) {
          var wSlug = toSlug(location.pathname);
          if (wSlug) {
            var wn = store.read('tiku-wrongn', '{}');
            wn[wSlug] = (wn[wSlug] || 0) + 1;
            var wk = Object.keys(wn);
            while (wk.length > 500) {
              var minK = wk[0];
              wk.forEach(function (k) { if (wn[k] < wn[minK]) minK = k; });
              delete wn[minK]; wk = Object.keys(wn);
            }
            store.write('tiku-wrongn', wn);
          }
        }
      }
      touchKpCard(Array.prototype.map.call(document.querySelectorAll('a[href^="/kaoshi/"]'), function (a) { return a.getAttribute('href'); }), ok || revealed);
      paintQSide();
      if (sheetRender) sheetRender();
      opts.forEach(function (b) {
        var k = b.dataset.key; b.setAttribute('aria-checked', chosen.indexOf(k) >= 0 ? 'true' : 'false');
        b.disabled = true;
        if (answer.indexOf(k) >= 0) { markOption(b, 'correct'); }
        else if (chosen.indexOf(k) >= 0) { markOption(b, 'wrong'); }
        else { markOption(b, 'dim'); }
      });
      if (verdict) {
        verdict.classList.remove('hidden'); verdict.classList.add('flex');
        var suffix = (revealed ? ' · 已看解析，本次不计分' : qtNote(qms)) + prevPickNote(prevPick, chosenSet, ok);
        if (ok) {
          verdict.classList.add('border-emerald-200', 'bg-emerald-50');
          verdict.innerHTML = '<p class="text-sm font-medium text-emerald-800">回答正确 · 正确答案 ' + answer + suffix + '</p>';
        } else {
          verdict.classList.add('border-red-200', 'bg-red-50');
          verdict.innerHTML = '<p class="text-sm font-medium text-red-800">回答错误 · 正确答案 ' + answer + suffix + '</p>';
        }
      }
      if (submitBtn) { submitBtn.classList.add('hidden'); }
      collapseAct(reveal, '[data-pre]');
      showAnalysis();
      /* 全站正确率（attempts≥5 才展示，<50% 标易错） */
      if (analysis && !analysis.querySelector('.js-qstat')) {
        var qsSlug = toSlug(location.pathname);
        fetch('/api/qstats?slugs=' + encodeURIComponent(qsSlug))
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var it = (d.items || [])[0];
            if (!it || it.attempts < 5 || analysis.querySelector('.js-qstat')) return;
            var pct = Math.round(it.correct / it.attempts * 100);
            var line = document.createElement('p');
            line.className = 'js-qstat mt-2 text-[13px] text-muted';
            line.textContent = '全站正确率 ' + pct + '% · ' + it.attempts + ' 人做过' + (it.mis ? ' · 易错项 ' + it.mis : '') + (it.avgms ? ' · 平均用时 ' + Math.round(it.avgms / 1000) + ' 秒' : '');
            if (pct < 50) {
              var badge = document.createElement('span');
              badge.className = 'ml-2 rounded bg-red-100 px-1.5 py-0.5 text-[12px] font-medium text-red-700';
              badge.textContent = '易错';
              line.appendChild(badge);
            }
            analysis.insertBefore(line, analysis.firstElementChild ? analysis.firstElementChild.nextSibling : null);
          }).catch(function () { /* noop */ });
      }
    }
    opts.forEach(function (b) {
      wireExcl(b);
      b.addEventListener('click', function () {
        if (answered || exclClick(b)) return;
        var k = b.dataset.key;
        if (!multi) { finish([k]); return; }
        var i = picked.indexOf(k);
        if (i >= 0) {
          picked.splice(i, 1); b.setAttribute('aria-checked', 'false');
          b.classList.remove('border-brand-600', 'bg-brand-50', 'ring-1', 'ring-brand-600'); b.classList.add('border-line');
        } else {
          picked.push(k); b.setAttribute('aria-checked', 'true');
          b.classList.remove('border-line'); b.classList.add('border-brand-600', 'bg-brand-50', 'ring-1', 'ring-brand-600');
        }
        if (submitBtn) { submitBtn.classList.toggle('hidden', picked.length === 0); submitBtn.classList.toggle('flex', picked.length > 0); }
      });
    });
    if (submitBtn) { submitBtn.addEventListener('click', function () { if (!answered && picked.length > 0) finish(picked); }); }
    if (reveal) { reveal.addEventListener('click', function () { revealed = true; collapseAct(reveal, '#reveal, #hint-btn'); showAnalysis(); analysis && analysis.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }); }
    /* 背题模式（与操作台 ws-browse 同一存储键 tiku-browse）：直接亮正确项+解析，走「已看解析不计分」路径；模考/每日一练卷内不生效 */
    function browseReveal() {
      answered = true; revealed = true; clearExcl();
      opts.forEach(function (b) {
        b.disabled = true; b.setAttribute('aria-checked', 'false');
        markOption(b, answer.indexOf(b.dataset.key) >= 0 ? 'correct' : 'dim');
      });
      if (submitBtn) { submitBtn.classList.add('hidden'); submitBtn.classList.remove('flex'); }
      if (verdict) {
        verdict.classList.remove('hidden'); verdict.classList.add('flex', 'border-amber-200', 'bg-amber-50');
        verdict.textContent = '';
        var vp = document.createElement('p');
        vp.className = 'text-sm font-medium text-amber-800';
        vp.textContent = '背题模式 · 正确答案 ' + answer + ' · 本题不计分';
        var off = document.createElement('button');
        off.type = 'button';
        off.className = '-my-3.5 shrink-0 py-3.5 text-sm font-medium text-amber-800 underline';
        off.textContent = '关闭背题模式';
        off.addEventListener('click', function () { store.write('tiku-browse', 0); location.reload(); });
        verdict.appendChild(vp); verdict.appendChild(off);
      }
      collapseAct(reveal, '[data-pre]');
      showAnalysis();
    }
    if (store.read('tiku-browse', 'null') === 1 && !/[?&]from=(mock|daily)(&|$)/.test(location.search)) { browseReveal(); }
    var hintBtn = document.getElementById('hint-btn');
    if (hintBtn) {
      hintBtn.addEventListener('click', function () {
        if (answered) return;
        var box = document.getElementById('hint-box');
        if (box) { box.hidden = false; }
        (hintBtn.closest('.js-act') || hintBtn).remove();
      });
    }
    try {
      if (/[?&]from=daily(&|$)/.test(location.search)) {
        var dq = JSON.parse(sessionStorage.getItem('tiku-daily-queue') || 'null');
        var cur = toSlug(location.pathname);
        var di = dq && dq.slugs ? dq.slugs.indexOf(cur) : -1;
        if (di >= 0) {
          var back = document.getElementById('quiz-back');
          if (back) { back.href = '/daily/'; back.setAttribute('aria-label', '返回每日一练'); }
          var nn = document.getElementById('nav-next');
          if (nn) {
            if (di < dq.slugs.length - 1) { nn.href = '/q/' + dq.slugs[di + 1] + '/?from=daily'; uncross(nn); }
            else { nn.href = '/daily/'; endLabel(nn, '完成', '返回每日一练'); }
          }
          var np = document.getElementById('nav-prev');
          if (np && di > 0) { np.href = '/q/' + dq.slugs[di - 1] + '/?from=daily'; uncross(np); }
        }
      }
    } catch (_) { /* noop */ }
    writeLastQ();
    initMockMode();
    document.addEventListener('keydown', function (e) {
      if (e.target && /INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return;
      var key = e.key.toUpperCase();
      if (!answered) {
        var byLetter = opts.filter(function (b) { return b.dataset.key === key; })[0];
        if (e.shiftKey && byLetter) { e.preventDefault(); exclToggle(byLetter); return; }
        var byDigit = /^[1-9]$/.test(key) ? opts[parseInt(key, 10) - 1] : null;
        var target = byLetter || byDigit;
        if (target) { target.click(); return; }
      }
      if (document.getElementById('q-nav')) return;
      if (e.key === 'ArrowLeft') { var p = document.getElementById('nav-prev'); if (p) location.href = p.href; }
      if (e.key === 'ArrowRight') { var n = document.getElementById('nav-next'); if (n) location.href = n.href; }
    });
    var noteTa = document.getElementById('note-ta');
    if (noteTa) { bindNote(noteTa, document.getElementById('note-msg'), toSlug(location.pathname)); }
    var fbForm = document.getElementById('fb-form');
    if (fbForm) {
      var fbMsg = document.getElementById('fb-msg');
      var fbSlug = fbForm.dataset.slug;
      var fbDone = false;
      try { fbDone = sessionStorage.getItem('tiku-fb:' + fbSlug) === '1'; } catch (_) { /* noop */ }
      function fbThanks() { fbForm.hidden = true; fbMsg.hidden = false; }
      if (fbDone) fbThanks();
      var fbBusy = false;
      fbForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (fbDone || fbBusy) return;
        fbBusy = true;
        var btn = fbForm.querySelector('button[type="submit"]');
        var oldLabel = btn.textContent;
        btn.disabled = true; btn.textContent = '提交中…';
        var err = document.getElementById('fb-err');
        if (err) err.hidden = true;
        var kindInput = fbForm.querySelector('input[name="fb-kind"]:checked');
        fetch('/api/feedback', {
          method: 'POST',
          headers: postHeaders(),
          body: JSON.stringify({
            slug: fbSlug,
            kind: kindInput ? kindInput.value : 'other',
            detail: String(fbForm.querySelector('textarea[name="fb-detail"]').value || '').slice(0, 500),
            qa: qaOn() || undefined
          })
        }).then(function (r) {
          if (!r.ok) return rejectWith(r, '提交失败，请稍后重试');
          fbDone = true;
          try { sessionStorage.setItem('tiku-fb:' + fbSlug, '1'); } catch (_) { /* noop */ }
          saveFbk(fbSlug, kindInput ? kindInput.value : 'other', String(fbForm.querySelector('textarea[name="fb-detail"]').value || ''));
          fbThanks();
        }).catch(function (e) {
          if (!err) {
            err = document.createElement('p');
            err.id = 'fb-err';
            err.className = 'text-sm text-red-600';
            err.setAttribute('role', 'status');
            btn.parentNode.insertBefore(err, btn.nextSibling);
          }
          err.textContent = shownMsg(e, '提交失败，请稍后重试');
          err.hidden = false;
        }).finally(function () {
          fbBusy = false;
          btn.disabled = false; btn.textContent = oldLabel;
        });
      });
    }
    var disc = document.getElementById('disc');
    if (disc) {
      var dSlug = disc.dataset.slug;
      var dList = document.getElementById('disc-list');
      var dEmpty = document.getElementById('disc-empty');
      var dForm = document.getElementById('disc-form');
      var dNick = document.getElementById('disc-nick');
      var dTa = document.getElementById('disc-ta');
      var dMsg = document.getElementById('disc-msg');
      try { dNick.value = localStorage.getItem('tiku-nick') || ''; } catch (_) { /* noop */ }
      /* 评论动作（有用/删除/举报）失败提示：挂在该条评论按钮行之后的红字（空串移除） */
      function rowNote(li, text) {
        var p = li.querySelector(':scope > .js-disc-err');
        if (!text) { if (p) p.remove(); return; }
        if (!p) {
          p = document.createElement('p'); p.className = 'js-disc-err mt-1 text-[12px] text-red-600'; p.setAttribute('role', 'status');
          var sub = li.querySelector(':scope > ul'); if (sub) li.insertBefore(p, sub); else li.appendChild(p);
        }
        p.textContent = text;
      }
      function actFail(r) { return r.ok ? r.json() : rejectWith(r, '操作失败，请稍后重试'); }
      /* 「有用」点赞：tiku-clike 记录已点评论 id，防重复 */
      function likeBtn(slug, it, li) {
        var btn = document.createElement('button');
        btn.type = 'button';
        var n = it.likes || 0;
        var liked = !it.id || store.readList('tiku-clike').indexOf(it.id) >= 0;
        function paint() {
          btn.textContent = '有用' + (n > 0 ? ' ' + n : '');
          btn.disabled = liked;
          btn.className = liked
            ? 'mt-2 tap-y inline-flex h-7 items-center rounded-full bg-brand-50 px-2.5 text-[12px] font-medium text-brand-700'
            : 'mt-2 tap-y inline-flex h-7 items-center rounded-full border border-line bg-white px-2.5 text-[12px] text-muted hover:text-ink';
        }
        paint();
        btn.addEventListener('click', function () {
          if (liked || !it.id) return;
          liked = true; paint();
          fetch('/api/comment/like', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ slug: slug, id: it.id })
          }).then(actFail).then(function (j) {
            if (!j || !j.ok) { var e = new Error('操作失败，请稍后重试'); e.shown = true; throw e; }
            n = j.likes; var ids = store.readList('tiku-clike'); ids.push(it.id); store.write('tiku-clike', ids); paint(); rowNote(li, '');
          }).catch(function (e) { liked = false; paint(); rowNote(li, shownMsg(e, '操作失败，请稍后重试')); });
        });
        return btn;
      }
      /* 删除自己的评论：tiku-ctok 保存发表时领取的令牌 {id: token}，保留最近 200 条 */
      function readTok() { try { var o = JSON.parse(localStorage.getItem('tiku-ctok') || '{}'); return o && typeof o === 'object' ? o : {}; } catch (_) { return {}; } }
      function saveTok(id, token) {
        try {
          var o = readTok(); o[id] = token;
          var ks = Object.keys(o); if (ks.length > 200) { ks.sort(function (a, b) { return a - b; }).slice(0, ks.length - 200).forEach(function (k) { delete o[k]; }); }
          localStorage.setItem('tiku-ctok', JSON.stringify(o));
        } catch (_) { /* noop */ }
      }
      /* 删除成功后清本机残留：本条及其下回复（li[data-id]）的 tiku-ctok 令牌与 tiku-clike 已赞 id */
      function forgetTok(li) {
        var ids = [li.getAttribute('data-id')].concat(Array.prototype.map.call(li.querySelectorAll('li[data-id]'), function (n) { return n.getAttribute('data-id'); })).filter(Boolean);
        try {
          var o = readTok(); ids.forEach(function (id) { delete o[id]; });
          localStorage.setItem('tiku-ctok', JSON.stringify(o));
        } catch (_) { /* noop */ }
        var likes = store.readList('tiku-clike').filter(function (id) { return ids.indexOf(String(id)) < 0; });
        store.write('tiku-clike', likes);
      }
      function delBtn(it, li) {
        var tok = readTok()[it.id];
        if (!tok) return null;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ml-2 mt-2 tap-y inline-flex h-7 items-center rounded-full border border-line bg-white px-2.5 text-[12px] text-muted hover:text-red-600';
        btn.textContent = '删除';
        btn.addEventListener('click', function () {
          if (!window.confirm('删除这条评论？' + ((it.pid || 0) > 0 ? '' : '其下回复会一并删除。'))) return;
          btn.disabled = true;
          fetch('/api/comment/delete', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ slug: dSlug, id: it.id, token: tok })
          }).then(actFail).then(function (j) {
            if (!j || !j.ok) { var e = new Error('操作失败，请稍后重试'); e.shown = true; throw e; }
            if (!((it.pid || 0) > 0)) { delete dSubLists[it.id]; dTotal = Math.max(0, dTotal - 1); paintCount(); }
            forgetTok(li);
            li.remove();
            dEmpty.hidden = dList.children.length > 0;
          }).catch(function (e) { btn.disabled = false; rowNote(li, shownMsg(e, '操作失败，请稍后重试')); });
        });
        return btn;
      }
      /* 举报：tiku-rtok 匿名令牌（首次生成），tiku-crep 记录已举报 id，多人举报自动隐藏 */
      function rtok() {
        try {
          var t = localStorage.getItem('tiku-rtok');
          if (!t) {
            t = '';
            var a = new Uint8Array(16); crypto.getRandomValues(a);
            for (var i = 0; i < a.length; i++) { t += ('0' + a[i].toString(16)).slice(-2); }
            localStorage.setItem('tiku-rtok', t);
          }
          return t;
        } catch (_) { return ''; }
      }
      function reportBtn(it, li) {
        if (!it.id || readTok()[it.id]) return null;
        var btn = document.createElement('button');
        btn.type = 'button';
        var done = store.readList('tiku-crep').indexOf(it.id) >= 0;
        function paint() {
          btn.textContent = done ? '已举报' : '举报';
          btn.disabled = done;
          btn.className = done
            ? 'ml-2 mt-2 tap-y inline-flex h-7 items-center rounded-full bg-slate-100 px-2.5 text-[12px] text-muted'
            : 'ml-2 mt-2 tap-y inline-flex h-7 items-center rounded-full border border-line bg-white px-2.5 text-[12px] text-muted hover:text-red-600';
        }
        paint();
        btn.addEventListener('click', function () {
          if (done) return;
          if (!window.confirm('举报这条评论（辱骂/广告/严重误导）？多人举报后将被隐藏。')) return;
          var t = rtok(); if (!t) return;
          btn.disabled = true;
          fetch('/api/comment/report', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ slug: dSlug, id: it.id, token: t })
          }).then(actFail).then(function (j) {
            if (!j || !j.ok) { var e = new Error('操作失败，请稍后重试'); e.shown = true; throw e; }
            done = true; var ids = store.readList('tiku-crep'); ids.push(it.id); store.write('tiku-crep', ids); paint(); rowNote(li, '');
            if (j.hidden) {
              if (!((it.pid || 0) > 0)) { delete dSubLists[it.id]; dTotal = Math.max(0, dTotal - 1); paintCount(); }
              li.remove();
              dEmpty.hidden = dList.children.length > 0;
            }
          }).catch(function (e) { btn.disabled = false; rowNote(li, shownMsg(e, '操作失败，请稍后重试')); });
        });
        return btn;
      }
      /* 回复模式状态：非空时表单提交带 parent（楼中楼，仅一层） */
      var dReply = null;
      var dReplyBar = document.createElement('p');
      dReplyBar.className = 'text-[13px] text-brand-700';
      dReplyBar.hidden = true;
      var dReplyCancel = document.createElement('button');
      dReplyCancel.type = 'button';
      dReplyCancel.className = 'ml-2 underline';
      dReplyCancel.textContent = '取消';
      dReplyCancel.addEventListener('click', function () { dReply = null; dReplyBar.hidden = true; });
      dForm.insertBefore(dReplyBar, dForm.firstChild);
      var dSubLists = {};
      function subList(id) {
        if (!dSubLists[id]) { dSubLists[id] = document.createElement('ul'); dSubLists[id].className = 'mt-2 space-y-2 border-l-2 border-line pl-3'; }
        return dSubLists[id];
      }
      function discRow(it) {
        var isReply = (it.pid || 0) > 0;
        var li = document.createElement('li');
        li.className = isReply ? 'rounded-lg bg-white p-2.5' : 'rounded-xl bg-slate-50 p-3';
        if (it.id) li.setAttribute('data-id', String(it.id));
        var head = document.createElement('p');
        head.className = 'text-[12px] text-muted';
        var dt = new Date((it.t || 0) * 1000);
        head.textContent = (it.nick || '匿名考友') + ' · ' + (dt.getMonth() + 1) + '月' + dt.getDate() + '日';
        var bodyP = document.createElement('p');
        bodyP.className = 'mt-1 whitespace-pre-wrap text-[14px] leading-relaxed';
        bodyP.textContent = it.content || '';
        li.appendChild(head); li.appendChild(bodyP);
        li.appendChild(likeBtn(dSlug, it, li));
        if (!isReply && it.id) {
          var rb = document.createElement('button');
          rb.type = 'button';
          rb.className = 'ml-2 mt-2 tap-y inline-flex h-7 items-center rounded-full border border-line bg-white px-2.5 text-[12px] text-muted hover:text-ink';
          rb.textContent = '回复';
          rb.addEventListener('click', function () {
            dReply = { id: it.id, nick: it.nick || '匿名考友' };
            dReplyBar.textContent = '回复 @' + dReply.nick;
            dReplyBar.appendChild(dReplyCancel);
            dReplyBar.hidden = false;
            dTa.focus();
          });
          li.appendChild(rb);
        }
        if (it.id) { var db = delBtn(it, li); if (db) li.appendChild(db); }
        if (it.id) { var rp = reportBtn(it, li); if (rp) li.appendChild(rp); }
        if (!isReply && it.id) { li.appendChild(subList(it.id)); }
        return li;
      }
      var dCount = document.getElementById('disc-count');
      var dTotal = 0;
      function paintCount() { if (dCount) dCount.textContent = dTotal > 0 ? '（' + dTotal + '）' : ''; }
      var dSort = 'hot';
      var dSortWrap = document.createElement('div');
      dSortWrap.className = 'mt-2 flex gap-1.5';
      var dSortBtns = {};
      function paintSort() {
        ['hot', 'new'].forEach(function (s) {
          dSortBtns[s].className = 'tap-y inline-flex h-7 items-center rounded-full px-2.5 text-[12px] ' +
            (dSort === s ? 'bg-brand-700 font-medium text-white' : 'border border-line bg-white text-muted hover:text-ink');
          dSortBtns[s].setAttribute('aria-pressed', dSort === s ? 'true' : 'false');
        });
      }
      ['hot', 'new'].forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = s === 'hot' ? '最热' : '最新';
        b.addEventListener('click', function () {
          if (dSort === s || dMoreBusy) return;
          dSort = s; paintSort();
          dList.textContent = ''; dSubLists = {}; dPage = 0;
          loadDiscPage(0).catch(function () { dEmpty.hidden = false; });
        });
        dSortBtns[s] = b;
        dSortWrap.appendChild(b);
      });
      paintSort();
      dList.parentNode.insertBefore(dSortWrap, dList);
      var dMore = document.createElement('button');
      dMore.type = 'button';
      dMore.className = 'mt-3 inline-flex h-10 md:h-9 items-center rounded-lg border border-line bg-white px-3.5 text-[13px] text-muted hover:text-ink';
      dMore.textContent = '加载更多讨论';
      dMore.hidden = true;
      dList.parentNode.insertBefore(dMore, dEmpty);
      var dPage = 0;
      function loadDiscPage(page) {
        return fetch('/api/comments?slug=' + encodeURIComponent(dSlug) + '&page=' + page + '&sort=' + dSort)
          .then(function (r) { return r.ok ? r.json() : { items: [], total: 0, more: false }; })
          .then(function (j) {
            var items = (j && j.items) || [];
            var tops = items.filter(function (it) { return !(it.pid > 0); });
            var reps = items.filter(function (it) { return it.pid > 0; }).sort(function (a, b) { return (a.t - b.t) || (a.id - b.id); });
            tops.forEach(function (it) { dList.appendChild(discRow(it)); });
            reps.forEach(function (it) { if (dSubLists[it.pid]) dSubLists[it.pid].appendChild(discRow(it)); });
            dTotal = (j && j.total) || 0;
            paintCount();
            dEmpty.hidden = dList.children.length > 0;
            dMore.hidden = !(j && j.more);
          });
      }
      loadDiscPage(0).catch(function () { dEmpty.hidden = false; });
      var dMoreBusy = false;
      dMore.addEventListener('click', function () {
        if (dMoreBusy) return;
        dMoreBusy = true; dMore.disabled = true; dMore.textContent = '加载中…';
        dPage += 1;
        loadDiscPage(dPage).catch(function () { dPage -= 1; }).finally(function () {
          dMoreBusy = false; dMore.disabled = false; dMore.textContent = '加载更多讨论';
        });
      });
      var dBusy = false;
      dForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (dBusy) return;
        var content = String(dTa.value || '').trim();
        if (content.length < 2) { dMsg.textContent = '至少写 2 个字'; dMsg.hidden = false; return; }
        dBusy = true;
        var btn = dForm.querySelector('button[type="submit"]');
        btn.disabled = true; btn.textContent = '发表中…';
        dMsg.hidden = true;
        try { var nickV = String(dNick.value || '').trim(); if (nickV) localStorage.setItem('tiku-nick', nickV); } catch (_) { /* noop */ }
        fetch('/api/comment', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ slug: dSlug, nick: String(dNick.value || ''), content: content, parent: dReply ? dReply.id : 0 })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
          if (!res.ok) throw new Error((res.j && res.j.error) || '发表失败');
          var item = res.j.item;
          if (res.j.token && item.id) { saveTok(item.id, res.j.token); }
          if (item.pid > 0 && dSubLists[item.pid]) { dSubLists[item.pid].appendChild(discRow(item)); }
          else { dList.insertBefore(discRow(item), dList.firstChild); }
          if (!(item.pid > 0)) { dTotal += 1; paintCount(); }
          dReply = null; dReplyBar.hidden = true;
          dEmpty.hidden = true;
          dTa.value = '';
          dMsg.textContent = '已发表'; dMsg.className = 'text-[13px] text-emerald-700'; dMsg.hidden = false;
        }).catch(function (err2) {
          dMsg.textContent = (err2 && err2.message) || '发表失败，请稍后重试'; dMsg.className = 'text-[13px] text-red-600'; dMsg.hidden = false;
        }).finally(function () {
          dBusy = false;
          btn.disabled = false; btn.textContent = '发表讨论';
        });
      });
    }
    /* 收藏切换后同步「我的状态」行里的「已收藏 ★」chip（行不存在则新建，行空则移除） */
    function syncFavChip(on) {
      var stem = document.getElementById('stem'); if (!stem) return;
      var row = document.getElementById('st-row');
      var c = document.getElementById('st-fav');
      if (row && c && c.parentNode === row && row.querySelector('#st-w')) {
        /* SSR 占位行：只切 chip 显隐，行按是否还有可见 chip 决定 */
        c.classList.toggle('hidden', !on);
        var vis = row.querySelectorAll('span[id]:not(.hidden)').length > 0;
        row.classList.toggle('hidden', !vis);
        row.classList.toggle('flex', vis);
        return;
      }
      if (on && !c) {
        if (!row) {
          row = document.createElement('div');
          row.id = 'st-row';
          row.className = 'mt-3 flex flex-wrap items-center gap-2 text-xs';
          row.setAttribute('role', 'group');
          row.setAttribute('aria-label', '我与本题的学习状态');
          var lab = document.createElement('span');
          lab.className = 'text-muted'; lab.textContent = '我的状态：';
          row.appendChild(lab);
          stem.parentNode.insertBefore(row, stem);
        }
        c = document.createElement('span');
        c.id = 'st-fav';
        c.className = 'rounded-full px-2.5 py-1 font-medium bg-amber-50 text-amber-700';
        c.textContent = '已收藏 ★';
        row.appendChild(c);
      } else if (!on && c) {
        c.remove();
        if (row && row.children.length <= 1) row.remove();
      }
    }
    var fav = document.getElementById('fav');
    if (fav) {
      var favKey = 'tiku-fav'; var slug = location.pathname;
      function paint(on) {
        fav.setAttribute('aria-pressed', on ? 'true' : 'false');
        fav.setAttribute('aria-label', on ? '已收藏，点击取消' : '收藏本题');
        fav.className = on ? 'grid size-11 shrink-0 place-items-center rounded-xl border border-amber-300 bg-amber-50 text-amber-700' : 'grid size-11 shrink-0 place-items-center rounded-xl border border-line bg-white text-muted hover:bg-slate-50';
        fav.querySelector('svg').setAttribute('fill', on ? 'currentColor' : 'none');
      }
      paint(store.readList(favKey).indexOf(slug) >= 0);
      fav.addEventListener('click', function () {
        var favs = store.readList(favKey); var i = favs.indexOf(slug);
        if (i >= 0) { favs.splice(i, 1); } else { favs.push(slug); }
        store.write(favKey, favs);
        paint(i < 0);
        syncFavChip(i < 0);
      });
    }
  }

  /* ---------- 限时模考：题目页模考模式 ---------- */
  function readMock() {
    try { return JSON.parse(sessionStorage.getItem('tiku-mock') || 'null'); } catch (_) { return null; }
  }
  function initMockMode() {
    if (!/[?&]from=mock(&|$)/.test(location.search)) return;
    var mk = readMock(); var cur = toSlug(location.pathname);
    if (!mk || !mk.slugs || !mk.end || mk.done) return;
    var mi = mk.slugs.indexOf(cur);
    if (mi < 0) return;
    var back = document.getElementById('quiz-back');
    if (back && mk.paper) { back.href = mk.paper; back.setAttribute('aria-label', '返回模考试卷'); }
    var nn = document.getElementById('nav-next');
    if (nn) {
      if (mi < mk.slugs.length - 1) { nn.href = '/q/' + mk.slugs[mi + 1] + '/?from=mock'; uncross(nn); }
      else { nn.href = '/mock/result/'; endLabel(nn, '交卷', '查看成绩'); }
    }
    var np = document.getElementById('nav-prev');
    if (np && mi > 0) { np.href = '/q/' + mk.slugs[mi - 1] + '/?from=mock'; uncross(np); }
    /* 末题交卷前确认：提示未作答题数 */
    if (nn && mi === mk.slugs.length - 1) {
      nn.addEventListener('click', function (e) {
        var cur2 = readMock(); if (!cur2 || !cur2.slugs) return;
        var un = cur2.slugs.filter(function (s) { return !cur2.ok || !(s in cur2.ok); }).length;
        var msg = un > 0 ? '还有 ' + un + ' 题未作答，确定交卷？' : '确定交卷查看成绩？';
        if (!window.confirm(msg)) { e.preventDefault(); }
      });
    }
    /* 倒计时胶囊（服务端渲染的占位元素），到时自动交卷 */
    var chip = document.getElementById('mock-timer');
    if (!chip) return;
    chip.classList.remove('hidden');
    function tick() {
      var left = Math.floor((mk.end - Date.now()) / 1000);
      if (left <= 0) { location.href = '/mock/result/'; return; }
      var m = Math.floor(left / 60); var s = left % 60;
      chip.textContent = '第 ' + (mi + 1) + '/' + mk.slugs.length + ' 题 · ' + m + ':' + (s < 10 ? '0' : '') + s;
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* 限时模考开卷已迁至 /practice/ 做题操作台（practice.js）；tiku-mock 仅供历史链接回放 */

  /* ---------- 限时模考：成绩页（/mock/result/） ---------- */
  function initMockResult() {
    var box = document.getElementById('mock-result'); if (!box) return;
    var mk = readMock();
    if (!mk || !mk.slugs || !mk.start) {
      /* 新模考流程成绩即操作台报告：找本标签页最近一次已交卷的模考会话直接跳过去 */
      var best = null; var bestT = 0;
      try {
        for (var i = 0; i < sessionStorage.length; i++) {
          var k = sessionStorage.key(i) || '';
          if (k.indexOf('tiku-ws:?') !== 0 || !/[?&]mode=mock(line)?(&|$)/.test(k)) continue;
          var s = readWs(k.slice(8));
          if (!s || !s.submitted) continue;
          var t = s.end || s.start || 1;
          if (t > bestT) { bestT = t; best = k.slice(8); }
        }
      } catch (_) { /* noop */ }
      if (best && WS_URL_RE.test('/practice/' + best)) location.replace('/practice/' + best);
      return;
    }
    box.classList.remove('hidden');
    var empty = document.getElementById('mock-empty'); if (empty) empty.remove();
    var totalN = mk.slugs.length; var okN = 0; var wrong = [];
    mk.slugs.forEach(function (s) {
      if (mk.ok && mk.ok[s] === true) { okN++; }
      else { wrong.push(s); }
    });
    var scorePct = Math.round(okN / totalN * 100);
    document.getElementById('mock-score').textContent = scorePct + ' 分';
    var ring = document.getElementById('mock-ring');
    if (ring) {
      var CIRC = 2 * Math.PI * 52;
      requestAnimationFrame(function () { ring.setAttribute('stroke-dasharray', (CIRC * scorePct / 100) + ' ' + CIRC); });
    }
    document.getElementById('mock-correct').textContent = okN + '/' + totalN;
    var used = mk.used != null ? mk.used : Math.min(Math.floor((Date.now() - mk.start) / 1000), mk.dur || 900);
    document.getElementById('mock-time').textContent = Math.floor(used / 60) + ' 分 ' + (used % 60) + ' 秒';
    var again = document.getElementById('mock-again');
    if (again && mk.paper) { again.href = mk.paper; }
    /* 各知识点正确率条形：拉取全卷题目的知识点名称后聚合 */
    fetch('/api/questions?slugs=' + encodeURIComponent(mk.slugs.join(',')))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var agg = {}; var order = [];
        (d.items || []).forEach(function (q) {
          var names = (q.kp_names || '').split('|').filter(Boolean);
          if (names.length === 0) { names = ['未归类']; }
          var isOk = mk.ok && mk.ok[q.slug] === true;
          names.forEach(function (nm) {
            if (!agg[nm]) { agg[nm] = { ok: 0, total: 0 }; order.push(nm); }
            agg[nm].total++; if (isOk) agg[nm].ok++;
          });
        });
        var list = document.getElementById('mock-kp-list'); if (!list || order.length === 0) return;
        var emptyKp = document.getElementById('mock-kp-empty'); if (emptyKp) emptyKp.style.display = 'none';
        var parentOf = kpParentMap(order);
        var byAcc = function (a, b) { return agg[a].ok / agg[a].total - agg[b].ok / agg[b].total; };
        var nested = [];
        order.filter(function (nm) { return !parentOf[nm]; }).sort(byAcc).forEach(function (p) {
          nested.push(p);
          order.filter(function (c) { return parentOf[c] === p; }).sort(byAcc).forEach(function (c) { nested.push(c); });
        });
        nested.forEach(function (nm) {
          var pct = Math.round(agg[nm].ok / agg[nm].total * 100);
          var par = parentOf[nm] || '';
          var row = document.createElement('div'); if (par) row.className = 'pl-3';
          var head = document.createElement('div'); head.className = 'flex items-baseline justify-between gap-2 text-[13px]';
          var label = document.createElement('span'); label.className = 'min-w-0 truncate text-slate-700';
          if (par) {
            var srP = document.createElement('span'); srP.className = 'sr-only'; srP.textContent = par + '·';
            var mark = document.createElement('span'); mark.className = 'text-muted'; mark.textContent = '└ ';
            label.appendChild(srP); label.appendChild(mark); label.appendChild(document.createTextNode(nm.slice(par.length + 1)));
          } else label.textContent = nm;
          var val = document.createElement('span'); val.className = 'shrink-0 text-muted tabular-nums'; val.textContent = agg[nm].ok + '/' + agg[nm].total + ' · ' + pct + '%';
          head.appendChild(label); head.appendChild(val);
          var track = document.createElement('div'); track.className = 'mt-1 h-2 overflow-hidden rounded-full bg-slate-100';
          var bar = document.createElement('div');
          bar.className = 'h-full rounded-full ' + (pct >= 80 ? 'bg-emerald-500' : pct >= 50 ? 'bg-amber-400' : 'bg-red-400');
          bar.style.width = pct + '%';
          track.appendChild(bar);
          row.appendChild(head); row.appendChild(track); list.appendChild(row);
        });
      }).catch(function () { /* noop */ });
    if (wrong.length > 0) {
      var emptyWrong = document.getElementById('mock-wrong-empty'); if (emptyWrong) emptyWrong.style.display = 'none';
      fetch('/api/questions?slugs=' + encodeURIComponent(wrong.join(',')))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var list = document.getElementById('mock-wrong-list');
          (d.items || []).forEach(function (q) {
            var a = document.createElement('a');
            a.href = '/q/' + q.slug + '/';
            a.className = 'block rounded-xl border border-line bg-white p-4 shadow-sm transition hover:border-brand-600/40 hover:shadow-md';
            var stem = document.createElement('p'); stem.className = 'line-clamp-2 text-[15px] leading-relaxed text-ink'; stem.textContent = q.stem;
            var meta = document.createElement('p'); meta.className = 'mt-2 flex flex-wrap items-center gap-2 text-[13px] text-slate-600';
            var pill = document.createElement('span'); pill.className = 'rounded-full bg-slate-100 px-2 py-0.5'; pill.textContent = QTYPE[q.qtype] || q.qtype;
            meta.appendChild(pill);
            var d2 = document.createElement('span'); d2.textContent = '难度 ' + stars(q.difficulty); meta.appendChild(d2);
            a.appendChild(stem); a.appendChild(meta); list.appendChild(a);
          });
        }).catch(function () { /* noop */ });
    }
    /* 保留成绩至下一次开考覆盖，误刷新不丢报告；标记 done 防止题目页继续按模考模式计时 */
    try { mk.done = true; mk.used = used; sessionStorage.setItem('tiku-mock', JSON.stringify(mk)); } catch (_) { /* noop */ }
  }

  /* 考点名列表里去掉「有子在场」的父（子名 = 父名 + 「·」前缀）：父子题集重叠，同时命中时保留更具体的子 */
  function dropKpParents(names) {
    return names.filter(function (p) { return !names.some(function (c) { return c !== p && c.indexOf(p + '·') === 0; }); });
  }
  /* 同一列表内 子名 → 在场的父名（无父在场则不收录，按普通行展示） */
  function kpParentMap(names) {
    var m = {};
    names.forEach(function (nm) {
      names.forEach(function (o) { if (o !== nm && nm.indexOf(o + '·') === 0 && (!m[nm] || o.length > m[nm].length)) m[nm] = o; });
    });
    return m;
  }

  /* ---------- 首页「弱项专练」卡：最近做题按考点聚合，正确率最低的薄弱考点直达连刷 ---------- */
  function initWeakSpot() {
    var box = document.getElementById('weak-card'); if (!box) return;
    var label = document.getElementById('weak-label');
    var go = document.getElementById('weak-go');
    var smartGo = document.getElementById('weak-smart');
    var tag = document.getElementById('weak-tag');
    if (!label || !go) return;
    /* BOOT_JS 已按 ws-weak 首帧占位；未命中时不收走卡片（避免布局偏移），回退掌握度入口 */
    function fallback() {
      if (!document.documentElement.classList.contains('ws-weak')) return;
      label.textContent = '近期暂无明显薄弱考点';
      if (tag) { tag.textContent = '掌握度'; tag.classList.remove('bg-red-50', 'text-red-600'); tag.classList.add('bg-emerald-50', 'text-emerald-700'); }
      go.href = '/my/#mastery-h'; go.textContent = '看掌握度 →'; go.removeAttribute('aria-label');
      if (smartGo) smartGo.style.display = 'none';
    }
    var done = store.readList('tiku-done').map(toSlug).filter(Boolean);
    if (done.length < 5) { fallback(); return; }
    var recent = done.slice(-100);
    var wrongSet = {};
    store.readList('tiku-wrong').forEach(function (p) { var s = toSlug(p); if (s) wrongSet[s] = 1; });
    fetch('/api/questions?slugs=' + encodeURIComponent(recent.join(',')))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var agg = {}; var order = [];
        (d.items || []).forEach(function (q) {
          var names = (q.kp_names || '').split('|').filter(Boolean);
          var slugsArr = (q.kp_slugs || '').split('|').filter(Boolean);
          names.forEach(function (nm, ni) {
            if (!agg[nm]) { agg[nm] = { ok: 0, total: 0, href: '', kpHref: '', smartHref: '' }; order.push(nm); }
            agg[nm].total++; if (!wrongSet[q.slug]) agg[nm].ok++;
            if (!agg[nm].href && slugsArr[ni] && q.exam_slug && q.subject_slug) {
              agg[nm].href = '/practice/?mode=kp&exam=' + encodeURIComponent(q.exam_slug) + '&subject=' + encodeURIComponent(q.subject_slug) + '&kp=' + encodeURIComponent(slugsArr[ni]);
              agg[nm].kpHref = '/kaoshi/' + encodeURIComponent(q.exam_slug) + '/' + encodeURIComponent(q.subject_slug) + '/kp/' + encodeURIComponent(slugsArr[ni]) + '/';
              agg[nm].smartHref = smartPracticeHref(q.exam_slug, q.subject_slug);
            }
          });
        });
        /* 与科目页考点索引/考点页/智能选题同口径（WEAK_MIN_DONE / WEAK_ACC）；二级题型「父名·子名」与父同时候选时只推更具体的子（docs/plan-r528） */
        var weak = dropKpParents(order.filter(function (nm) {
          var a = agg[nm];
          return a.total >= WEAK_MIN_DONE && a.ok / a.total < WEAK_ACC && a.href;
        }));
        weak.sort(function (x, y) { return agg[x].ok / agg[x].total - agg[y].ok / agg[y].total; });
        /* 无薄弱考点时回退「近期错过」：有错题但样本未达薄弱阈值的考点（错多者先），与智能练习 missPick 同序 */
        var missed = weak.length > 0 ? [] : dropKpParents(order.filter(function (nm) {
          var a = agg[nm];
          return a.total < WEAK_MIN_DONE && a.ok < a.total && a.href;
        })).sort(function (x, y) {
          return (agg[y].total - agg[y].ok) - (agg[x].total - agg[x].ok) || agg[x].ok / agg[x].total - agg[y].ok / agg[y].total;
        });
        var nm = weak[0] || missed[0];
        if (!nm) { fallback(); return; }
        var a = agg[nm];
        var isMiss = weak.length === 0;
        var tail = isMiss
          ? ' · 错 ' + (a.total - a.ok) + '/' + a.total
          : ' · 正确率 ' + Math.round(a.ok / a.total * 100) + '%（' + a.ok + '/' + a.total + '）';
        label.textContent = '';
        if (a.kpHref) {
          var ka = document.createElement('a');
          ka.href = a.kpHref;
          ka.className = 'font-medium text-ink underline decoration-line underline-offset-2 hover:text-brand-700';
          ka.textContent = nm;
          label.appendChild(ka);
          label.appendChild(document.createTextNode(tail));
        } else {
          label.textContent = nm + tail;
        }
        if (isMiss && tag) {
          tag.textContent = '近期错过';
          tag.classList.remove('bg-red-50', 'text-red-600');
          tag.classList.add('bg-amber-50', 'text-amber-700');
        }
        go.href = a.href;
        go.setAttribute('aria-label', (isMiss ? '连刷近期错过考点「' : '连刷薄弱考点「') + nm + '」');
        /* 375 单行卡片保留「连刷」，智能练习入口 ≥sm 才显示（标签 truncate 优先） */
        if (smartGo && a.smartHref) { smartGo.href = a.smartHref; smartGo.classList.remove('hidden'); smartGo.classList.add('max-sm:hidden', 'inline-flex'); }
        box.classList.remove('hidden'); box.classList.add('flex');
      }).catch(fallback);
  }

  /* ---------- 底部导航「练习」按钮：续练优先（tiku-last.u 会话 > p 单题 > tiku-exam 本线随机 > 默认全库随机） ---------- */
  function initTabPractice() {
    var tab = document.getElementById('tab-practice'); if (!tab) return;
    var last = store.read('tiku-last', 'null');
    var wsHref = lastWsHref(last);
    /* 频道/科目页当页考试线优先于记忆（科目页 initKpProgress 写记忆晚于本函数） */
    var here = /^\/kaoshi\/([\w-]{1,40})\//.exec(location.pathname);
    var ex = here ? here[1] : store.read('tiku-exam', 'null');
    if (wsHref) { tab.href = wsHref; }
    else if (last && last.p && Q_PATH_RE.test(last.p)) { tab.href = last.p; }
    else if (typeof ex === 'string' && /^[\w-]{1,40}$/.test(ex)) { tab.href = '/practice/?mode=random&exam=' + encodeURIComponent(ex) + '&n=10'; }
  }

  /* ---------- 首页：续练入口与本地统计 ---------- */
  function initHome() {
    var cont = document.getElementById('home-continue'); if (!cont) return;
    var last = store.read('tiku-last', 'null');
    /* 优先操作台会话（u：完整站内路径+查询串），回退单题路径（p） */
    var lastHref = lastWsHref(last);
    var isWs = Boolean(lastHref);
    if (!lastHref && last && last.p && Q_PATH_RE.test(last.p)) { lastHref = last.p; }
    if (lastHref) {
      cont.href = lastHref;
      var prog = isWs && last.n > 0 && last.a >= 0 && last.a <= last.n ? '已答 ' + last.a + '/' + last.n : '';
      cont.querySelector('span').textContent = '继续上次练习' + (last.s ? '：' + last.s : '') + '（本地记录）';
      var progEl = document.getElementById('home-cont-prog');
      if (progEl) { progEl.textContent = prog; progEl.hidden = !prog; }
      cont.hidden = false; cont.classList.remove('hidden'); cont.classList.add('inline-flex');
    } else {
      cont.hidden = true;
    }
    /* 练习台宫格：错题重刷入口注入本地错题数与直达链接（有到期错题优先「今日待复习」队列） */
    var qw = document.getElementById('quick-wrong');
    if (qw) {
      var wrongSlugs = store.readList('tiku-wrong').map(toSlug).filter(Boolean);
      var sub = qw.querySelector('.js-quick-sub');
      var dueSlugs = wrongDue().map(toSlug).filter(Boolean);
      if (dueSlugs.length > 0) {
        qw.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(shuffleSlugs(dueSlugs.slice(0, 20)).join(',')) + '&review=1';
        if (sub) sub.textContent = '待复习 ' + dueSlugs.length + ' 题';
      } else if (wrongSlugs.length > 0) {
        qw.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(shuffleSlugs(wrongSlugs.slice(-20)).join(','));
        if (sub) sub.textContent = wrongSlugs.length + ' 题待重刷';
      } else if (sub) { sub.textContent = '暂无错题'; }
    }
    var st = store.read('tiku-stats', '{"a":0,"c":0}');
    var statsEl = document.getElementById('home-stats');
    if (statsEl && st.a > 0) {
      /* 独占一行（BOOT_JS ws-stats 首帧已预留 min-h-5），不再追加到首行末尾撑宽 hero 左栏把 CTA 行挤下去 */
      statsEl.textContent = '已做 ' + store.readList('tiku-done').length + ' 题 · 作答 ' + st.a + ' 次 · 正确率 ' + Math.max(0, Math.min(100, Math.round(st.c / st.a * 100))) + '%';
      statsEl.classList.remove('hidden'); statsEl.classList.add('block');
    }
  }

  /* 题页 ≥xl 常驻「本考点答题卡」侧栏（SSR 直出全部题号，几何固定）：只按 tiku-done/tiku-wrong 着色，当前格滚入可视区；作答后再刷一次 */
  function paintQSide() {
    var grid = document.getElementById('q-side-grid'); if (!grid) return;
    var done = {}; var wrong = {};
    store.readList('tiku-done').forEach(function (p) { var s = toSlug(p); if (s) done[s] = 1; });
    store.readList('tiku-wrong').forEach(function (p) { var s = toSlug(p); if (s) wrong[s] = 1; });
    Array.prototype.forEach.call(grid.querySelectorAll('a[data-q]'), function (a) {
      var s = a.dataset.q; if (!done[s]) return;
      var bad = !!wrong[s];
      a.classList.remove('border', 'border-line', 'bg-white', 'text-slate-600', 'bg-emerald-700', 'bg-red-600');
      a.classList.add(bad ? 'bg-red-600' : 'bg-emerald-700', 'text-white');
      a.setAttribute('aria-label', (a.getAttribute('aria-label') || '').replace(/，.*$/, '') + (bad ? '，答错' : '，已答对'));
    });
  }
  /* 答题卡格 roving tabindex：仅当前格进 Tab 序，方向键 / Home / End 在卡内移动，不冒泡到全局 ←/→ 切题 */
  function bindSheetKeys(grid) {
    grid.addEventListener('keydown', function (e) {
      if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      var cells = Array.prototype.slice.call(grid.querySelectorAll('a'));
      var idx = cells.indexOf(document.activeElement);
      if (idx < 0 || cells.length < 2) return;
      var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').length || 1;
      var to;
      if (e.key === 'ArrowRight') to = idx + 1;
      else if (e.key === 'ArrowLeft') to = idx - 1;
      else if (e.key === 'ArrowDown') to = idx + cols;
      else if (e.key === 'ArrowUp') to = idx - cols;
      else if (e.key === 'Home') to = 0;
      else if (e.key === 'End') to = cells.length - 1;
      else return;
      e.preventDefault(); e.stopPropagation();
      to = Math.max(0, Math.min(cells.length - 1, to));
      if (to === idx) return;
      cells[idx].tabIndex = -1;
      cells[to].tabIndex = 0;
      cells[to].focus();
    });
  }
  function initQSide() {
    paintQSide();
    var grid = document.getElementById('q-side-grid'); if (!grid) return;
    bindSheetKeys(grid);
    var cur = grid.querySelector('a[aria-current="page"]');
    if (!cur) { var first = grid.querySelector('a'); if (first) first.tabIndex = 0; return; }
    if (cur.offsetParent) cur.scrollIntoView({ block: 'center' });
  }
  /* ---------- 题目页：可展开答题卡（模考/每日一练队列） ---------- */
  /* 作答后由 grade 调用，底栏「答题卡」按钮百分比与格子着色即时刷新（与侧栏 paintQSide 同步，不必重新打开抽屉） */
  var sheetRender = null;
  function initSheet() {
    var btn = document.getElementById('sheet-btn'); if (!btn) return;
    var panel = document.getElementById('sheet-panel'); var grid = document.getElementById('sheet-grid');
    if (!panel || !grid) return;
    var cur = toSlug(location.pathname);
    var slugs = null; var suffix = ''; var isMock = false; var kpMode = false;
    if (/[?&]from=mock(&|$)/.test(location.search)) {
      var mk = readMock();
      if (mk && mk.slugs && mk.slugs.length > 0) { slugs = mk.slugs; suffix = '?from=mock'; isMock = true; }
    } else if (/[?&]from=daily(&|$)/.test(location.search)) {
      try {
        var dq = JSON.parse(sessionStorage.getItem('tiku-daily-queue') || 'null');
        if (dq && dq.slugs && dq.slugs.length > 0) { slugs = dq.slugs; suffix = '?from=daily'; }
      } catch (_) { /* noop */ }
    }
    if (!slugs) {
      /* 非队列态：<xl 用同一抽屉承接 R531 侧栏的本考点题序（SSR #q-side-grid 为数据源，按钮已 SSR 直出 flex xl:hidden） */
      var cells = document.querySelectorAll('#q-side-grid a[data-q]');
      if (cells.length < 2) return;
      slugs = Array.prototype.map.call(cells, function (a) { return a.dataset.q; });
      kpMode = true;
      var title = document.getElementById('sheet-title');
      if (title) title.textContent = '本考点答题卡';
    } else {
      /* 队列态（模考/每日）用底栏答题卡抽屉，隐藏 ≥xl 本考点侧栏与抽屉内本考点 CTA，避免两套题序并存 */
      var side = document.getElementById('q-side'); if (side) side.style.display = 'none';
      var sheetCta = document.getElementById('sheet-cta'); if (sheetCta) sheetCta.hidden = true;
      btn.classList.remove('hidden', 'xl:hidden'); btn.classList.add('flex');
      btn.parentElement.classList.remove('grid-cols-[1fr_44px_1.4fr]', 'xl:grid-cols-[1fr_44px_1.4fr]');
      btn.parentElement.classList.add('grid-cols-[1fr_59px_44px_1.4fr]');
    }
    function state(s) {
      if (isMock) {
        var mk2 = readMock(); var okm = (mk2 && mk2.ok) || {};
        return s in okm ? (okm[s] === true ? 'ok' : 'wrong') : 'blank';
      }
      var done = store.readList('tiku-done'); var wrongL = store.readList('tiku-wrong');
      var p = '/q/' + s + '/';
      if (done.indexOf(p) < 0) return 'blank';
      return wrongL.indexOf(p) >= 0 ? 'wrong' : 'ok';
    }
    function render() {
      grid.innerHTML = '';
      var answered = 0;
      slugs.forEach(function (s, i) {
        var st = state(s); if (st !== 'blank') answered++;
        var a = document.createElement('a');
        a.href = '/q/' + s + '/' + suffix;
        a.textContent = String(i + 1);
        var cls = 'grid h-10 md:h-9 place-items-center rounded-lg text-sm font-medium tabular-nums ';
        cls += st === 'ok' ? 'bg-emerald-700 text-white' : st === 'wrong' ? 'bg-red-600 text-white' : 'border border-line bg-white text-slate-600';
        if (s === cur) { cls += ' ring-2 ring-brand-600 ring-offset-1'; a.setAttribute('aria-current', 'page'); }
        a.className = cls;
        a.setAttribute('aria-label', '第 ' + (i + 1) + ' 题' + (st === 'ok' ? '，已答对' : st === 'wrong' ? '，答错' : '，未作答'));
        a.tabIndex = s === cur ? 0 : -1;
        grid.appendChild(a);
      });
      if (!grid.querySelector('a[aria-current="page"]') && grid.firstElementChild) grid.firstElementChild.tabIndex = 0;
      var pctEl = document.getElementById('sheet-pct');
      if (pctEl) pctEl.textContent = Math.round(answered / slugs.length * 100) + '%';
    }
    render();
    sheetRender = render;
    bindSheetKeys(grid);
    btn.addEventListener('click', function () {
      var open = panel.hidden;
      if (open) render();
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) return;
      /* 抽屉在 DOM 里位于按钮之前：打开后把焦点移到当前题格，键盘 / 读屏才顺序可达（Esc 还给按钮） */
      var curEl = grid.querySelector('a[aria-current="page"]') || grid.firstElementChild;
      if (!curEl) return;
      if (kpMode) curEl.scrollIntoView({ block: 'center' });
      curEl.focus({ preventScroll: true });
    });
    /* Esc 关闭抽屉并把焦点还给按钮（与 practice.js 答题卡一致）；输入控件内不拦截 */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || panel.hidden) return;
      if (e.target && /INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return;
      panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      btn.focus();
    });
  }

  /* ---------- 每日一练：连续打卡天数 ---------- */
  function initStreak() {
    var el = document.getElementById('daily-streak'); if (!el) return;
    var days = store.read('tiku-days', '{}');
    var n = 0; var d = new Date();
    if (!days[localDay(d)]) { d.setDate(d.getDate() - 1); }
    while (days[localDay(d)]) { n++; d.setDate(d.getDate() - 1); }
    if (n > 0) {
      el.textContent = '已连续打卡 ' + n + ' 天，再接再厉 🔥';
      el.classList.remove('hidden');
    } else {
      el.hidden = true;
    }
  }

  /* ---------- 每日一练/每周模考落地页：你的名次回显（tiku-rank） ---------- */
  function initMyRank() {
    var el = document.getElementById('my-rank'); if (!el) return;
    var key = el.getAttribute('data-rank-key') || '';
    var rk = store.read('tiku-rank', '{}');
    var v = rk[key];
    var weekly = key.indexOf('weekly:') === 0;
    if (!v || typeof v.r !== 'number') {
      /* 模考开始页：无名次（交卷未上报/QA）但 tiku-hist 有本卷记录 → 同一 pill 显本机最高分（BOOT ws-mrank 同口径） */
      var start = document.getElementById('mock-start');
      var hb = key.indexOf('daily:') !== 0 && start ? histBest()[start.getAttribute('data-mock-s') || ''] : undefined;
      if (hb === undefined) { el.hidden = true; return; }
      el.textContent = (weekly ? '你本周最高 ' : '你在本卷最高 ') + hb + ' 分';
    } else {
      el.textContent = (key.indexOf('daily:') === 0 ? '你今天第 ' : weekly ? '你本周第 ' : '你在本卷第 ') + v.r + ' 名 · ' + v.p + ' 分';
    }
    el.hidden = false;
    el.classList.remove('hidden');
    /* 边缘缓存的 SSR「还没有人交卷，做第一个」与本人名次不能同屏 */
    var first = document.getElementById('daily-first'); if (first) first.remove();
  }

  /* /daily/ 今日排行榜随 /api/paper-score top 重建（与 SSR 同 class；边缘快照落后时才调用） */
  function renderDayTop(top) {
    var box = document.getElementById('day-top-list');
    if (!box || !Array.isArray(top) || top.length === 0) return;
    var RANK_CLS = ['bg-amber-100 text-amber-700', 'bg-slate-200 text-slate-700', 'bg-orange-100 text-orange-700'];
    var ol = document.createElement('ol');
    ol.className = 'divide-y divide-line overflow-hidden rounded-2xl border border-line bg-white shadow-sm';
    top.slice(0, 10).forEach(function (r, i) {
      var li = document.createElement('li'); li.className = 'flex items-center gap-3 px-4 py-3';
      var no = document.createElement('span');
      no.className = 'grid size-7 shrink-0 place-items-center rounded-full text-[13px] font-semibold tabular-nums ' + (RANK_CLS[i] || 'bg-slate-100 text-slate-500');
      no.setAttribute('aria-hidden', 'true'); no.textContent = String(i + 1);
      var nick = document.createElement('span'); nick.className = 'min-w-0 flex-1 truncate text-[15px] text-ink';
      nick.textContent = (r && r.nick) || '匿名考友';
      var pct = document.createElement('span'); pct.className = 'shrink-0 font-semibold text-brand-700 tabular-nums';
      pct.textContent = String(r && typeof r.pct === 'number' ? r.pct : 0) + ' 分';
      li.appendChild(no); li.appendChild(nick); li.appendChild(pct);
      ol.appendChild(li);
    });
    box.textContent = '';
    box.appendChild(ol);
    box.setAttribute('data-n', String(top.length));
  }

  /* ---------- /daily/ 今日交卷人数：SSR 走边缘缓存（≤1h），用 /api/paper-score 校正 ---------- */
  function initDailyStat() {
    var rank = document.getElementById('my-rank'); if (!rank) return;
    var key = rank.getAttribute('data-rank-key') || '';
    if (key.indexOf('daily:') !== 0) return;
    var stat = document.getElementById('daily-stat');
    var first = document.getElementById('daily-first');
    if (stat ? stat.getAttribute('data-live') !== '1' : !first) return;
    var ssrN = stat ? parseInt(stat.getAttribute('data-n') || '0', 10) || 0 : 0;
    if (!window.fetch) return;
    fetch('/api/paper-score?key=' + encodeURIComponent(key) + '&top=1').then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      if (!d || typeof d.n !== 'number' || d.n <= ssrN) return;
      renderDayTop(d.top);
      if (!stat) {
        stat = document.createElement('p');
        stat.id = 'daily-stat';
        stat.className = 'mt-2 w-fit rounded-full bg-black/20 px-3 py-1 text-[13px] text-white';
        /* initMyRank 可能已移除 #daily-first（本人交卷回访），此时挂在名次胶囊前 */
        var anchor = first && first.parentNode ? first : rank;
        anchor.parentNode.insertBefore(stat, anchor);
      }
      stat.textContent = '';
      stat.appendChild(document.createTextNode('今天已有 '));
      var n = document.createElement('span'); n.className = 'font-medium tabular-nums'; n.textContent = String(d.n); stat.appendChild(n);
      stat.appendChild(document.createTextNode(' 人交卷 · 平均 '));
      var a = document.createElement('span'); a.className = 'font-medium tabular-nums'; a.textContent = String(d.avg); stat.appendChild(a);
      stat.appendChild(document.createTextNode(' 分'));
      stat.setAttribute('data-n', String(d.n));
      first = document.getElementById('daily-first'); if (first) first.remove();
    }).catch(function () { /* 校正失败保留 SSR 快照 */ });
  }

  /* ---------- 排行榜昵称（tiku-nick）：/my/ 设置卡 + 落地页引导 ---------- */
  /* 与服务端 scoreNick（src/lib.ts NICK_URLISH_RE）同源；\p 类经 new RegExp 构造避开 es2017 产物目标 */
  var NICK_URLISH_RE;
  try { NICK_URLISH_RE = new RegExp('://|www\\.|@|\\.(com|cn|net|org|top|xyz|vip|cc|io|me|tv|info|shop|site|club|online)(?![\\p{L}\\p{N}])', 'iu'); }
  catch (_) { NICK_URLISH_RE = /:\/\/|www\.|@/i; }
  function normNick(v) {
    return String(v || '').replace(/[\u0000-\u001f\u007f\u200b-\u200f\u2028-\u202e\u2060-\u2064\ufeff]/g, '').replace(/\s+/g, ' ').trim().slice(0, 12).trim();
  }
  function initNick() {
    var cta = document.getElementById('nick-cta');
    if (cta) {
      var cur = '';
      try { cur = localStorage.getItem('tiku-nick') || ''; } catch (_) { /* noop */ }
      if (!cur.trim()) cta.hidden = false;
    }
    var input = document.getElementById('nick-input'); if (!input) return;
    var save = document.getElementById('nick-save');
    var msg = document.getElementById('nick-msg');
    try { input.value = localStorage.getItem('tiku-nick') || ''; } catch (_) { /* noop */ }
    save.addEventListener('click', function () {
      var v = normNick(input.value);
      if (v && NICK_URLISH_RE.test(v)) { msg.textContent = '昵称不能包含链接、网址或邮箱'; msg.className = 'mt-2 text-[13px] text-red-600'; return; }
      try { localStorage.setItem('tiku-nick', v); } catch (_) { /* noop */ }
      input.value = v;
      msg.textContent = v ? '已保存：之后交卷上榜将显示「' + v + '」' : '已清空：上榜将显示「匿名考友」';
      msg.className = 'mt-2 text-[13px] text-emerald-700';
    });
  }

  /* ---------- 首页：今日刷题目标进度（tiku-days + tiku-goal） ---------- */
  function initTodayGoal() {
    var box = document.getElementById('today-goal'); if (!box) return;
    var label = document.getElementById('tg-label');
    var bar = document.getElementById('tg-bar');
    var tail = document.getElementById('tg-tail');
    var GOALS = [10, 20, 50];
    function goal() {
      var g = parseInt(store.read('tiku-goal', '20'), 10);
      return GOALS.indexOf(g) >= 0 ? g : 20;
    }
    function planLeft(iso) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || ''); if (!m) return null;
      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      return Math.round((new Date(+m[1], +m[2] - 1, +m[3]) - today) / 86400000);
    }
    function activePlan() {
      var p = store.read('tiku-plan', 'null');
      if (!p || !p.e || !p.d || !(p.g > 0) || !p.s) return null;
      var left = planLeft(p.d);
      return left === null || left < 0 ? null : { p: p, left: left };
    }
    /* 计划考期已过（与 BOOT ws-planx 同判据）：首页尾部提示已结束并引向 /my/ 重设，而非默默退回「制定备考计划」 */
    function expiredPlan() {
      var p = store.read('tiku-plan', 'null');
      if (!p || !p.e || !p.d || !(p.g > 0) || !p.s) return null;
      var left = planLeft(p.d);
      return left !== null && left < 0 ? p : null;
    }
    function paint() {
      var days = store.read('tiku-days', '{}');
      var n = days[localDay(new Date())] || 0;
      var ap = activePlan();
      var g = ap ? ap.p.g : goal();
      var hit = n >= g;
      label.innerHTML = '今日作答 <span class="inline-block min-w-[2ch] text-right font-semibold text-brand-700 tabular-nums">' + n + '</span> / ' + (ap ? '计划' : '目标') + ' <span class="tabular-nums underline decoration-dotted underline-offset-4">' + g + '</span> 题';
      /* 可访问名称必须包含可见文本（WCAG 2.5.3），再附操作说明 */
      label.setAttribute('aria-label', label.textContent + '，' + (ap ? '点击去我的页面调整备考计划每日题量' : '点击切换目标 10、20、50 题'));
      bar.style.width = Math.min(n / g * 100, 100) + '%';
      bar.classList.toggle('bg-emerald-500', hit);
      bar.classList.toggle('bg-brand-600', !hit);
      var streak = 0; var d = new Date();
      if (!days[localDay(d)]) { d.setDate(d.getDate() - 1); }
      while (days[localDay(d)]) { streak++; d.setDate(d.getDate() - 1); }
      var head = (hit ? (ap ? '今日任务达成 ✓' : '今日目标达成 ✓') : '还差 ' + (g - n) + ' 题') + (streak > 0 ? ' · 🔥 连续 ' + streak + ' 天' : '');
      tail.textContent = '';
      tail.appendChild(document.createTextNode(head));
      var hist = store.read('tiku-hist', '[]');
      if (!Array.isArray(hist)) hist = [];
      var dailyDone = ap ? dailyDoneToday(hist) : false;
      if (ap) {
        tail.appendChild(document.createTextNode(' · ' + (ap.p.n || '考试') + (ap.left === 0 ? ' 今日开考' : ' 还有 ' + ap.left + ' 天') + ' · '));
        var go = document.createElement('a');
        go.href = hit ? planMoreHref(ap.p.e) : planQuotaHref(ap.p.e, n, g, dailyDone);
        go.textContent = hit ? '再练一组 →' : '去完成 →';
        go.className = '-my-2 inline-flex min-h-10 items-center font-medium text-brand-700 hover:underline';
        tail.appendChild(go);
      } else {
        var st0 = store.read('tiku-stats', '{"a":0,"c":0}');
        var ex0 = store.read('tiku-exam', 'null');
        if (!hit && typeof ex0 === 'string' && /^[\w-]{1,40}$/.test(ex0)) {
          /* 与 SSR #tg-pq 同结构（BOOT_JS data-exam / ws-stats / ws-tghit 决定首帧显隐与文案），重建不改几何：
             零作答 → 新人摸底 10 题；有作答未达标 → 补齐今日目标，题数取 5/10/15/20 中首个 ≥ 缺口（文案不含数字） */
          var fresh = !(st0.a > 0);
          var fillN = [5, 10, 15, 20].filter(function (k) { return k >= g - n; })[0] || 20;
          var pqw = document.createElement('span');
          pqw.id = 'tg-pq';
          pqw.appendChild(document.createTextNode(' · '));
          var pq = document.createElement('a');
          pq.href = '/practice/?mode=random&exam=' + encodeURIComponent(ex0) + '&n=' + (fresh ? 10 : fillN);
          pq.textContent = fresh ? '新人摸底 · 快速测 10 题 →' : '补齐今日目标 →';
          pq.className = (fresh ? 'js-pq-new' : 'js-pq-fill') + ' -my-2 inline-flex min-h-10 items-center font-medium text-brand-700 hover:underline';
          pqw.appendChild(pq);
          tail.appendChild(pqw);
        }
        /* 与 SSR 同字数（BOOT ws-planx 首帧已显「考期已过 · 」+「重设」），重建不改几何 */
        var xp = expiredPlan();
        tail.appendChild(document.createTextNode(xp ? ' · 考期已过 · ' : ' · '));
        var mk = document.createElement('a');
        mk.href = '/my/#plan-card';
        mk.textContent = xp ? '重设备考计划 →' : '制定备考计划 →';
        mk.className = '-my-2 inline-flex min-h-10 items-center font-medium text-brand-700 hover:underline';
        tail.appendChild(mk);
      }
      tail.classList.toggle('text-emerald-700', hit);
      tail.classList.toggle('text-muted', !hit);
      tail.classList.toggle('font-medium', hit);
      document.documentElement.classList.toggle('ws-tghit', hit);
      var tasksEl = document.getElementById('tg-tasks');
      if (tasksEl) {
        tasksEl.textContent = '';
        document.documentElement.classList.toggle('ws-plan', !!ap);
        if (ap) {
          var due = wrongDue();
          var dueSlugs = due.map(toSlug).filter(Boolean).slice(0, 20);
          var item = function (done, label, href) {
            var s = document.createElement('span');
            s.className = 'inline-flex items-center gap-1';
            var dot = document.createElement('span');
            dot.className = done ? 'font-bold text-emerald-700' : 'text-slate-400';
            dot.textContent = done ? '✓' : '○';
            dot.setAttribute('aria-hidden', 'true');
            s.appendChild(dot);
            if (done) {
              var t = document.createElement('span');
              t.className = 'text-emerald-700';
              t.textContent = label;
              s.appendChild(t);
            } else {
              var a = document.createElement('a');
              a.href = href;
              a.className = 'text-brand-700 hover:underline';
              a.textContent = label;
              s.appendChild(a);
            }
            tasksEl.appendChild(s);
          };
          item(dailyDone, '每日一练', '/daily/?exam=' + encodeURIComponent(ap.p.e));
          item(due.length === 0, due.length === 0 ? '错题复习' : '错题复习 ' + due.length + ' 题',
            dueSlugs.length
              ? '/practice/?mode=slugs&slugs=' + encodeURIComponent(shuffleSlugs(dueSlugs).join(',')) + '&review=1'
              : '/my/');
          item(n >= g, '刷题 ' + n + '/' + g, planQuotaHref(ap.p.e, n, g, dailyDone));
          item(weeklyMockDone(hist, ap.p.n), '本周模考', '/mock/' + encodeURIComponent(ap.p.e) + '/?paper=w');
          tasksEl.classList.remove('hidden');
          tasksEl.classList.add('flex');
        } else {
          tasksEl.classList.add('hidden');
          tasksEl.classList.remove('flex');
        }
      }
    }
    label.addEventListener('click', function () {
      if (activePlan()) { location.href = '/my/'; return; }
      var g = goal();
      store.write('tiku-goal', GOALS[(GOALS.indexOf(g) + 1) % GOALS.length]);
      paint();
    });
    paint();
    /* 考试线 tab 切换写入 tiku-exam 后重绘：新人「摸底 10 题」/「补齐今日目标」入口随所选线即时出现，不必刷新 */
    document.addEventListener('tiku:exam', paint);
    box.classList.remove('hidden'); box.classList.add('flex');
  }

  /* ---------- 首页：考试线宫格 tab 切换 ---------- */
  function initExamTabs() {
    var tabs = Array.prototype.slice.call(document.querySelectorAll('#exam-tabs [role="tab"]'));
    if (tabs.length === 0) return;
    var panels = Array.prototype.slice.call(document.querySelectorAll('[data-exam-panel]'));
    function activate(slug) {
      tabs.forEach(function (t) {
        var on = t.dataset.exam === slug;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.classList.toggle('border-line', on); t.classList.toggle('bg-white', on);
        t.classList.toggle('shadow-[0_4px_30px_rgba(207,218,230,0.4)]', on);
        t.classList.toggle('text-brand-700', on);
        t.classList.toggle('border-transparent', !on); t.classList.toggle('bg-transparent', !on);
        t.classList.toggle('text-slate-600', !on); t.classList.toggle('hover:bg-white/70', !on);
        var icon = t.querySelector('.js-exam-tab-icon');
        if (icon) { icon.classList.toggle('text-brand-700', on); icon.classList.toggle('text-slate-400', !on); }
        var bar = t.querySelector('.js-exam-tab-bar'); if (bar) bar.classList.toggle('hidden', !on);
      });
      panels.forEach(function (p) { p.hidden = p.dataset.examPanel !== slug; });
      /* 面板显隐由 CSS 按 <html data-exam> 决定（layout BOOT_JS 首帧前预挂载，避免 CLS） */
      document.documentElement.dataset.exam = slug;
    }
    function pick(slug) {
      activate(slug);
      document.documentElement.classList.add('ws-exam');
      store.write('tiku-exam', slug);
      document.dispatchEvent(new Event('tiku:exam'));
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(t.dataset.exam); });
      t.addEventListener('keydown', function (e) {
        var j = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : -1;
        if (j < 0 && e.key !== 'ArrowLeft') return;
        var nt = tabs[(j + tabs.length) % tabs.length];
        if (nt) { nt.focus(); pick(nt.dataset.exam); }
      });
    });
    var saved = store.read('tiku-exam', 'null');
    var ok = tabs.some(function (t) { return t.dataset.exam === saved; });
    /* 记忆的线已不存在（下线 / 改名）时 BOOT 按字面挂了 ws-exam，这里摘掉：失效记忆 = 未选线，hero / 宫格回默认句 */
    if (saved && !ok) document.documentElement.classList.remove('ws-exam');
    var init = ok ? saved : tabs[0].dataset.exam;
    activate(init);
  }

  /* ---------- 首页首次访问「选择考试线」引导 ---------- */
  function initOnboard() {
    var card = document.getElementById('home-onboard');
    if (!card) return;
    var tabs = Array.prototype.slice.call(document.querySelectorAll('#exam-tabs [role="tab"]'));
    var saved = store.read('tiku-exam', 'null');
    var hasExam = tabs.some(function (t) { return t.dataset.exam === saved; });
    var root = document.documentElement;
    if (hasExam || store.read('tiku-onboard', 'null') === 'skip') { root.classList.add('ws-ob-off'); card.hidden = true; return; }
    /* 引导卡 SSR 默认可见；BOOT_JS 只能按“有存值”预判，存值已失效（考试线下线）时这里改回显示 */
    root.classList.remove('ws-ob-off');
    card.hidden = false;
    card.classList.remove('hidden');
    Array.prototype.slice.call(card.querySelectorAll('.js-ob-exam')).forEach(function (b) {
      b.addEventListener('click', function () {
        store.write('tiku-exam', b.dataset.obExam);
        location.reload();
      });
    });
    var skip = document.getElementById('ob-skip');
    if (skip) skip.addEventListener('click', function () {
      store.write('tiku-onboard', 'skip');
      root.classList.add('ws-ob-off');
      card.hidden = true;
      card.classList.add('hidden');
    });
  }

  /* ---------- 科目页知识点索引：个人进度点亮（已做 x/y） ---------- */
  function initKpProgress() {
    var cells = Array.prototype.slice.call(document.querySelectorAll('[data-kp]'));
    if (cells.length === 0) return;
    var m = /^\/kaoshi\/([^/]+)\/([^/]+)\/$/.exec(location.pathname);
    if (!m) return;
    store.write('tiku-exam', m[1]);
    var done = {};
    store.readList('tiku-done').forEach(function (p) { var s = toSlug(p); if (s) done[s] = 1; });
    var wrong = {};
    store.readList('tiku-wrong').forEach(function (p) { var s = toSlug(p); if (s) wrong[s] = 1; });
    function pctEl(acc, weak, what) {
      var pct = Math.round(acc * 100);
      var pEl = document.createElement('span');
      pEl.className = weak ? 'font-medium text-rose-600' : pct >= 80 ? 'text-emerald-700' : 'text-amber-700';
      pEl.textContent = pct + '%';
      if (weak) { pEl.title = what; pEl.setAttribute('aria-label', '正确率 ' + pct + '%，' + what); }
      return pEl;
    }
    function doneEl(n, total) {
      var frag = document.createDocumentFragment();
      frag.appendChild(document.createTextNode('已做 '));
      var nEl = document.createElement('span'); nEl.className = 'font-medium text-brand-700'; nEl.textContent = String(n);
      frag.appendChild(nEl);
      frag.appendChild(document.createTextNode('/' + total));
      return frag;
    }
    fetch('/api/kpmap?exam=' + encodeURIComponent(m[1]) + '&subject=' + encodeURIComponent(m[2]))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var stats = kpPersonalStats(d.kps || []);
        cells.forEach(function (cell) {
          var st = stats[cell.dataset.kp];
          var n = st ? st.done : 0;
          if (n === 0) return;
          cell.textContent = '';
          cell.appendChild(doneEl(n, cell.dataset.total));
          /* 个人正确率（错题本口径）：已做 ≥3 才显示，<70% 标薄弱；样本不足但有错标「近期错过」（与 /my/ 同口径） */
          if (n >= WEAK_MIN_DONE) {
            cell.appendChild(document.createTextNode(' · '));
            cell.appendChild(pctEl(st.acc, st.weak, '薄弱考点'));
            if (st.weak) cell.dataset.kpWeak = '1';
          } else if (st.wrong > 0) {
            cell.appendChild(document.createTextNode(' · '));
            var mEl = document.createElement('span');
            mEl.className = 'text-amber-700'; mEl.textContent = '近期错过';
            mEl.setAttribute('aria-label', '近期错过，样本不足 ' + WEAK_MIN_DONE + ' 题');
            cell.appendChild(mEl);
            cell.dataset.kpMiss = '1';
          }
          cell.dataset.done = String(n);
        });
        /* 薄弱/错过计数：二级题型叶（kpmap p=父叶）与父叶同时命中只计子叶（同一话题不计两次，docs/plan-r528）；单元格自身标注不变 */
        var childHit = {};
        (d.kps || []).forEach(function (it) {
          if (!it.p) return;
          var c = document.querySelector('[data-kp="' + it.slug + '"]');
          if (c && (c.dataset.kpWeak || c.dataset.kpMiss)) childHit[it.p] = 1;
        });
        function countCell(cell) { return !childHit[cell.dataset.kp]; }
        var weakTotal = cells.filter(function (c) { return c.dataset.kpWeak && countCell(c); }).length;
        var missTotal = cells.filter(function (c) { return c.dataset.kpMiss && countCell(c); }).length;
        /* 根节点聚合：对子级题目集合求并集后去重计数（一题挂多考点只计一次），已做≥3 附正确率，子叶薄弱/错过数作徽标（折叠态可见） */
        var qsBy = {};
        (d.kps || []).forEach(function (it) { qsBy[it.slug] = it.q || []; });
        Array.prototype.slice.call(document.querySelectorAll('[data-kp-root]')).forEach(function (root) {
          var box = root.closest('details'); if (!box) return;
          var seen = {}; var x = 0; var y = 0; var wr = 0; var nW = 0; var nM = 0;
          Array.prototype.slice.call(box.querySelectorAll('[data-kp]')).forEach(function (cell) {
            if (cell.dataset.kpWeak && countCell(cell)) nW++;
            if (cell.dataset.kpMiss && countCell(cell)) nM++;
            (qsBy[cell.dataset.kp] || []).forEach(function (s) {
              if (seen[s]) return;
              seen[s] = 1; y++;
              if (done[s]) { x++; if (wrong[s]) wr++; }
            });
          });
          if (x === 0) return;
          root.textContent = '';
          var txt = document.createElement('span');
          txt.appendChild(doneEl(x, y));
          if (x >= WEAK_MIN_DONE) {
            var acc = 1 - wr / x;
            txt.appendChild(document.createTextNode(' · '));
            txt.appendChild(pctEl(acc, acc < WEAK_ACC, '模块正确率低于 70%'));
          }
          root.appendChild(txt);
          if (nW > 0 || nM > 0) {
            var badge = document.createElement('span');
            badge.className = 'inline-block whitespace-nowrap rounded-full px-1.5 py-0.5 text-[11px] font-medium ' + (nW > 0 ? 'bg-rose-100 text-rose-700' : 'bg-amber-100 text-amber-800');
            badge.textContent = nW > 0 ? '薄弱 ' + nW : '错过 ' + nM;
            badge.setAttribute('aria-label', nW > 0 ? nW + ' 个薄弱考点' : nM + ' 个近期错过考点');
            root.appendChild(badge);
          }
        });
        initKpWeakOnly(weakTotal, missTotal);
      }).catch(function () { /* noop */ });
  }

  /* 科目页「只看薄弱」：纯 DOM 显隐，隐去非薄弱/错过叶与无匹配根，匹配根展开；关闭时还原原 open 态 */
  function initKpWeakOnly(nW, nM) {
    var btn = document.getElementById('kp-weak-only');
    if (!btn || (nW === 0 && nM === 0)) return;
    var sel = nW > 0 ? '[data-kp-weak]' : '[data-kp-miss]';
    btn.textContent = (nW > 0 ? '只看薄弱 ' : '只看错过 ') + (nW > 0 ? nW : nM);
    btn.classList.remove('hidden'); btn.classList.add('inline-flex');
    var on = false; var prevOpen = [];
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-kp-root]')).map(function (r) { return r.closest('details'); }).filter(Boolean);
    btn.addEventListener('click', function () {
      on = !on;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      ['border-rose-200', 'bg-rose-50', 'text-rose-700', 'hover:bg-rose-100'].forEach(function (c) { btn.classList.toggle(c, !on); });
      ['border-rose-700', 'bg-rose-700', 'text-white'].forEach(function (c) { btn.classList.toggle(c, on); });
      roots.forEach(function (box, i) {
        var hit = 0;
        Array.prototype.slice.call(box.querySelectorAll('li')).forEach(function (li) {
          var match = !!li.querySelector(sel);
          if (match) hit++;
          li.hidden = on && !match;
        });
        if (on) { prevOpen[i] = box.open; box.hidden = hit === 0; if (hit > 0) box.open = true; }
        else { box.hidden = false; box.open = !!prevOpen[i]; }
      });
    });
  }

  /* ---------- 题目页：「我的状态」个人痕迹行（纯本地，无任何命中不渲染） ---------- */
  function initQStatus() {
    var stem = document.getElementById('stem');
    if (!stem || !document.getElementById('options')) return;
    var p = location.pathname;
    if (!toSlug(p)) return;
    var chips = [];
    function chip(text, cls) {
      var s = document.createElement('span');
      s.className = 'rounded-full px-2.5 py-1 font-medium ' + cls;
      s.textContent = text;
      chips.push(s);
    }
    var inWrong = store.readList('tiku-wrong').indexOf(p) >= 0;
    if (inWrong) {
      var wn = store.read('tiku-wrongn', '{}');
      var slug = toSlug(p);
      var n = wn[slug] || 0;
      var wk = store.read('tiku-wrongk', '{}');
      var stgN = Math.max(0, Math.min(2, wk[p] || 0));
      chip('错题本' + (n > 0 ? ' · 错 ' + n + ' 次' : '') + ' · 复习第 ' + (stgN + 1) + '/3 轮', 'bg-red-50 text-red-700');
      var wt = store.read('tiku-wrongt', '{}');
      var t = wt[p];
      if (typeof t !== 'number' || Math.floor(Date.now() / 1000) - t >= REVIEW_GAPS[stgN]) {
        chip('待复习', 'bg-amber-100 text-amber-800');
      }
    } else if (store.readList('tiku-wronggl').indexOf(p) >= 0) {
      chip('已出师 ✓', 'bg-emerald-50 text-emerald-700');
    } else if (store.readList('tiku-done').indexOf(p) >= 0) {
      chip('做过本题', 'bg-slate-100 text-slate-600');
    }
    if (store.readList('tiku-fav').indexOf(p) >= 0) chip('已收藏 ★', 'bg-amber-50 text-amber-700');
    chips.forEach(function (c) { if (c.textContent === '已收藏 ★') c.id = 'st-fav'; });
    var ssr = document.getElementById('st-row');
    if (ssr) {
      /* SSR 占位行（BOOT 首帧已按同规则控显）：在同一任务内写真实文案、接管显隐、移除 BOOT 注入的 style 与 html 标记 */
      var byText = {};
      chips.forEach(function (c) { byText[c.textContent] = c; });
      var wChip = chips.filter(function (c) { return c.textContent.indexOf('错题本') === 0; })[0];
      var wEl = document.getElementById('st-w');
      if (wEl) { wEl.textContent = wChip ? wChip.textContent : ''; wEl.classList.toggle('hidden', !wChip); }
      [['st-g', '已出师 ✓'], ['st-d', '做过本题'], ['st-r', '待复习'], ['st-fav', '已收藏 ★']].forEach(function (x) {
        var el = document.getElementById(x[0]);
        if (el) el.classList.toggle('hidden', !byText[x[1]]);
      });
      ssr.classList.toggle('hidden', chips.length === 0);
      ssr.classList.toggle('flex', chips.length > 0);
      var boot = document.getElementById('qst0');
      if (boot) boot.parentNode.removeChild(boot);
      document.documentElement.classList.remove('ws-qst', 'ws-qsw', 'ws-qsg', 'ws-qsd', 'ws-qsr', 'ws-qsf');
      return;
    }
    if (chips.length === 0) return;
    var row = document.createElement('div');
    row.id = 'st-row';
    row.className = 'mt-3 flex flex-wrap items-center gap-2 text-xs';
    row.setAttribute('role', 'group');
    row.setAttribute('aria-label', '我与本题的学习状态');
    var lab = document.createElement('span');
    lab.className = 'text-muted';
    lab.textContent = '我的状态：';
    row.appendChild(lab);
    chips.forEach(function (c) { row.appendChild(c); });
    stem.parentNode.insertBefore(row, stem);
  }

  /* ---------- 题目页：AI 答疑（POST /api/ai-ask，匿名令牌 tiku-aitok 每日限次） ---------- */
  function initAiAsk() {
    var fb = document.getElementById('fb');
    var slug = toSlug(location.pathname);
    if (!fb || !slug || !document.getElementById('options')) return;
    function mk(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text) n.textContent = text;
      return n;
    }
    function aiToken() {
      var t = '';
      try { t = localStorage.getItem('tiku-aitok') || ''; } catch (_) { /* noop */ }
      if (!/^[\w-]{8,64}$/.test(t)) {
        t = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : ('t' + Date.now() + Math.random().toString(36).slice(2, 10));
        try { localStorage.setItem('tiku-aitok', t); } catch (_) { /* noop */ }
      }
      return t;
    }
    function readAiLog() {
      return store.readList('tiku-ai').filter(function (v) {
        return v && typeof v.s === 'string' && typeof v.q === 'string' && typeof v.a === 'string' && typeof v.ts === 'number';
      });
    }
    function renderQA(q, a) {
      var qEl = mk('div', 'rounded-xl bg-white p-3 text-[14px] leading-relaxed');
      qEl.appendChild(mk('p', 'font-medium text-brand-800', '问：' + q));
      if (a) {
        var aEl = mk('div', 'mt-2 space-y-2 border-t border-line pt-2 text-[14px] leading-relaxed text-slate-700');
        String(a).split(/\n+/).forEach(function (p) {
          p = p.trim();
          if (p) aEl.appendChild(mk('p', '', p));
        });
        qEl.appendChild(aEl);
      }
      thread.appendChild(qEl);
      return qEl;
    }
    var det = mk('details', 'rounded-2xl border border-brand-200 bg-brand-50/40 p-4 shadow-sm');
    det.id = 'ai-ask';
    var sum = mk('summary', 'tap-y cursor-pointer py-1 text-sm font-semibold text-brand-800 hover:text-brand-900', 'AI 答疑：对解析还有疑问？');
    det.appendChild(sum);
    var thread = mk('div', 'mt-3 space-y-3');
    det.appendChild(thread);
    var past = readAiLog().filter(function (v) { return v.s === slug; }).slice(0, 5).reverse();
    if (past.length > 0) {
      thread.appendChild(mk('p', 'text-[12px] text-muted', '历史答疑 · ' + past.length + ' 条'));
      past.forEach(function (v) { renderQA(v.q, v.a); });
      sum.textContent = 'AI 答疑：对解析还有疑问？（' + past.length + ' 条历史）';
    }
    var chips = mk('div', 'mt-3 flex flex-wrap gap-2');
    var input = document.createElement('input');
    input.type = 'text'; input.maxLength = 200;
    input.id = 'ai-ask-q'; input.name = 'q';
    input.setAttribute('aria-label', 'AI 答疑问题');
    input.placeholder = '也可以自己输入问题…（2–200 字）';
    input.className = 'h-10 min-w-0 flex-1 rounded-lg border border-line bg-white px-3 text-sm focus:outline-hidden focus:ring-2 focus:ring-brand-600/40';
    var btn = mk('button', 'inline-flex h-10 shrink-0 items-center justify-center rounded-lg bg-brand-700 px-4 text-sm font-medium text-white hover:bg-brand-800 disabled:opacity-60', '提问');
    btn.type = 'button';
    var msg = mk('p', 'mt-2 text-[13px] text-muted', '');
    msg.hidden = true;
    var busy = false;
    function ask(q) {
      q = String(q || '').trim();
      if (busy || q.length < 2) return;
      busy = true; btn.disabled = true;
      msg.hidden = false; msg.className = 'mt-2 text-[13px] text-muted'; msg.textContent = 'AI 思考中…';
      var qEl = renderQA(q, '');
      fetch('/api/ai-ask', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ slug: slug, q: q, token: aiToken() })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); }).then(function (res) {
        if (!res.ok) throw new Error(res.d && res.d.error ? res.d.error : '请求失败');
        var aEl = mk('div', 'mt-2 space-y-2 border-t border-line pt-2 text-[14px] leading-relaxed text-slate-700');
        String(res.d.answer || '').split(/\n+/).forEach(function (p) {
          p = p.trim();
          if (p) aEl.appendChild(mk('p', '', p));
        });
        qEl.appendChild(aEl);
        msg.textContent = typeof res.d.left === 'number' ? '今日剩余 ' + res.d.left + ' 次 · AI 回答仅供参考' : 'AI 回答仅供参考';
        input.value = '';
        var log = readAiLog().filter(function (v) { return !(v.s === slug && v.q === q); });
        log.unshift({ s: slug, q: q.slice(0, 200), a: String(res.d.answer || '').slice(0, 500), ts: Math.floor(Date.now() / 1000) });
        store.write('tiku-ai', log.slice(0, 30));
      }).catch(function (e) {
        qEl.remove();
        msg.className = 'mt-2 text-[13px] text-red-600';
        msg.textContent = (e && e.message) ? e.message : 'AI 答疑暂不可用，请稍后重试';
      }).finally(function () {
        busy = false; btn.disabled = false;
      });
    }
    ['为什么选这个答案？', '其他选项错在哪里？', '换个通俗说法再讲一遍'].forEach(function (p) {
      var c = mk('button', 'inline-flex h-10 md:h-9 items-center rounded-lg border border-brand-200 bg-white px-3 text-[13px] text-brand-800 hover:bg-brand-50', p);
      c.type = 'button';
      c.addEventListener('click', function () { ask(p); });
      chips.appendChild(c);
    });
    det.appendChild(chips);
    var row = mk('div', 'mt-3 flex flex-wrap gap-2');
    row.appendChild(input); row.appendChild(btn);
    det.appendChild(row);
    det.appendChild(msg);
    btn.addEventListener('click', function () { ask(input.value); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); ask(input.value); } });
    fb.parentNode.insertBefore(det, fb);
  }

  /* ---------- 题目页：分享本题（系统分享优先，降级复制链接） ---------- */
  function initQShare() {
    var stem = document.getElementById('stem');
    var reveal = document.getElementById('reveal');
    if (!stem || !document.getElementById('options') || !reveal) return;
    if (!toSlug(location.pathname)) return;
    var line = reveal.closest('p');
    var ssr = document.getElementById('q-share');
    var btn = ssr || document.createElement('button');
    btn.type = 'button';
    btn.id = 'q-share';
    btn.className = 'h-10 items-center font-medium text-brand-700 hover:underline';
    btn.textContent = '分享本题';
    btn.addEventListener('click', function () {
      var url = location.href;
      var title = '刷题营 · ' + (stem.textContent || '').slice(0, 40);
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () { /* 用户取消 */ });
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          btn.textContent = '已复制链接 ✓';
          setTimeout(function () { btn.textContent = '分享本题'; }, 2000);
        }).catch(function () { /* 剪贴板不可用则静默 */ });
      }
    });
    if (ssr) return;
    appendAct(line, btn);
  }

  /* 底栏上一题 / 下一题被 daily / mock 队列改指向后，SSR 按科目顺序算出的「换考点」副标与 aria-label 不再成立，摘掉 */
  function uncross(a) {
    var sub = a.querySelector('.js-cross');
    if (sub) sub.remove();
    a.removeAttribute('aria-label');
  }
  /* 队列末题的 nav-next：主标 + 副标，<sm 竖排、≥sm 单行「主标 · 副标」（与 SSR navLabel 同型） */
  function endLabel(a, main, sub) {
    a.textContent = '';
    var w = document.createElement('span');
    w.className = 'flex flex-col items-center leading-tight sm:flex-row sm:gap-1';
    w.appendChild(document.createTextNode(main));
    var s = document.createElement('span');
    s.className = 'js-end text-[11px] text-white/90';
    var dot = document.createElement('span');
    dot.className = 'hidden sm:inline';
    dot.textContent = '· ';
    s.appendChild(dot);
    s.appendChild(document.createTextNode(sub));
    w.appendChild(s);
    a.appendChild(w);
    a.removeAttribute('aria-label');
  }

  /* 收起操作行中仅作答前有意义的项（与操作台判分即撤操作行同口径）：sel 命中的 .js-act 置 hidden（保留节点与 id），
     最后一个可见项的尾分隔符摘掉，无可见项则整行 hidden；可重入（看解析后再作答），appendAct 后续追加仍能按需补分隔符 */
  function collapseAct(anchor, sel) {
    var row = anchor && anchor.closest('p');
    if (!row) return;
    Array.prototype.slice.call(row.querySelectorAll(sel)).forEach(function (n) {
      var it = n.closest('.js-act');
      if (it) it.hidden = true;
    });
    var last = null;
    Array.prototype.slice.call(row.children).forEach(function (c) { if (!c.hidden) last = c; });
    if (!last) { row.hidden = true; return; }
    var sep = last.lastElementChild;
    if (sep && sep.getAttribute('aria-hidden') === 'true') sep.remove();
    if (row.__actEol) row.__actEol();
  }

  /* 操作行末尾追加一项（40px 真实盒）：分隔符（aria-hidden）与 SSR actItem 同约定挂在前一项尾部（前一项已有则不重复），新项本身不带 */
  function appendAct(line, ctrl) {
    var prev = line.lastElementChild;
    while (prev && prev.hidden) prev = prev.previousElementSibling;
    if (prev && !(prev.lastElementChild && prev.lastElementChild.getAttribute('aria-hidden') === 'true')) {
      var sep = document.createElement('span');
      sep.className = 'mx-1'; sep.setAttribute('aria-hidden', 'true'); sep.textContent = '·';
      prev.appendChild(sep);
    }
    var it = document.createElement('span');
    it.className = 'js-act inline-flex h-10 items-center';
    it.appendChild(ctrl);
    line.appendChild(it);
    if (line.__actEol) line.__actEol();
  }

  /* 操作行 flex-wrap 折行处的尾分隔符：每行最后一个可见项的「·」置 visibility:hidden（占位不回流，避免与折行互相触发），
     行尾不再悬挂「·」；折行位置随视口 / 字号 / 收起变化，经 ResizeObserver（行与各项）重算，无 RO 浏览器退回 resize */
  function actEolMark(row) {
    var kids = Array.prototype.slice.call(row.children).filter(function (c) { return !c.hidden && c.getClientRects().length > 0; });
    kids.forEach(function (c, i) {
      var sep = c.lastElementChild;
      if (!sep || sep.getAttribute('aria-hidden') !== 'true') return;
      var nxt = kids[i + 1];
      var eol = !!nxt && nxt.getBoundingClientRect().top > c.getBoundingClientRect().top + 1;
      sep.style.visibility = eol ? 'hidden' : '';
    });
  }
  function initActEol() {
    var first = document.getElementById('options') && document.querySelector('p > .js-act');
    var row = first && first.parentElement;
    if (!row) return;
    var mark = function () { actEolMark(row); };
    row.__actEol = mark;
    mark();
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(mark);
      ro.observe(row);
      Array.prototype.slice.call(row.children).forEach(function (c) { ro.observe(c); });
    } else window.addEventListener('resize', mark);
  }

  /* ---------- 题目页：练 3 道相似题（同考点，custom n=3 + x 排除本题） ---------- */
  function initQSimilar() {
    var reveal = document.getElementById('reveal');
    var slug = toSlug(location.pathname);
    if (!reveal || !slug || !document.getElementById('options')) return;
    if (document.getElementById('q-similar')) return;
    var kp = document.querySelector('a[href^="/kaoshi/"][href*="/kp/"]');
    var m = kp && /^\/kaoshi\/([\w-]+)\/([\w-]+)\/kp\/([\w-]+)\/$/.exec(kp.getAttribute('href') || '');
    if (!m) return;
    var line = reveal.closest('p');
    var a = document.createElement('a');
    a.id = 'q-similar';
    a.className = 'inline-flex h-10 items-center font-medium text-brand-700 hover:underline';
    a.href = '/practice/?mode=custom&exam=' + m[1] + '&subject=' + m[2] + '&kp=' + m[3] + '&n=3&x=' + encodeURIComponent(slug);
    a.textContent = '练 3 道相似题';
    appendAct(line, a);
  }

  /* ---------- 题目页：本考点 上一题/下一题 顺序导航（复用 /api/kpmap，fail-closed） ---------- */
  /* 队列态（html.ws-qq，daily / mock）：←→ 键与滑动改走底栏已改写的队列 href（含 ?from=），与底栏「下一题」同源；
     队列首 / 末（底栏是科目序 prev 或「完成 / 交卷」出口）不动，非队列态回考点序 */
  var QQ_HREF_RE = /^\/q\/[^/?#]+\/\?from=(daily|mock)(&|$)/;
  function qqStepHref(dir, fallback) {
    if (!document.documentElement.classList.contains('ws-qq')) return fallback;
    var np = document.getElementById('nav-prev'); var nn = document.getElementById('nav-next');
    var ph = np ? np.getAttribute('href') || '' : ''; var nh = nn ? nn.getAttribute('href') || '' : '';
    if (!QQ_HREF_RE.test(ph) && !QQ_HREF_RE.test(nh)) return fallback;
    var h = dir < 0 ? ph : nh;
    return QQ_HREF_RE.test(h) ? h : '';
  }
  function bindQNavKeys(prevHref, nextHref) {
    /* 键盘翻题：←/→ 跳相邻题；输入控件聚焦时不拦截 */
    document.addEventListener('keydown', function (ev) {
      if (ev.defaultPrevented || ev.altKey || ev.ctrlKey || ev.metaKey || ev.shiftKey) return;
      var t = ev.target;
      var tag = t && t.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (t && t.isContentEditable)) return;
      if (ev.key === 'ArrowLeft') { var ph = qqStepHref(-1, prevHref); if (ph) location.href = ph; }
      else if (ev.key === 'ArrowRight') { var nh = qqStepHref(1, nextHref); if (nh) location.href = nh; }
    });
  }
  function initQNav() {
    var slug = toSlug(location.pathname);
    if (!slug || !document.getElementById('options') || !document.getElementById('reveal')) return;
    var ssrNav = document.getElementById('q-nav');
    if (ssrNav) {
      var dp = ssrNav.getAttribute('data-prev'); var dn = ssrNav.getAttribute('data-next');
      bindQNavKeys(dp ? '/q/' + dp + '/' : '', dn ? '/q/' + dn + '/' : '');
      return;
    }
    var kp = document.querySelector('a[href^="/kaoshi/"][href*="/kp/"]');
    var m = kp && /^\/kaoshi\/([\w-]+)\/([\w-]+)\/kp\/([\w-]+)\/$/.exec(kp.getAttribute('href') || '');
    if (!m) return;
    fetch('/api/kpmap?exam=' + encodeURIComponent(m[1]) + '&subject=' + encodeURIComponent(m[2]))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var it = (d.kps || []).filter(function (k) { return k.slug === m[3]; })[0];
        var qs = (it && it.q) || [];
        var i = qs.indexOf(slug);
        if (i < 0 || qs.length < 2) return;
        var host = document.getElementById('related') || document.getElementById('analysis') || document.getElementById('options');
        if (!host.parentNode) return;
        var bar = document.createElement('nav');
        bar.id = 'q-nav';
        bar.className = 'mt-4 flex items-center justify-between gap-3 rounded-xl border border-line bg-white px-4 py-3 text-sm shadow-sm';
        bar.setAttribute('aria-label', '本考点题目导航');
        if (i > 0) {
          var prev = document.createElement('a');
          prev.className = '-my-2.5 inline-flex min-h-10 items-center whitespace-nowrap font-medium text-brand-700 hover:underline';
          prev.href = '/q/' + qs[i - 1] + '/';
          prev.textContent = '← 上一题';
          bar.appendChild(prev);
        } else {
          var ph = document.createElement('span'); ph.className = 'text-muted'; ph.textContent = '已是第一题';
          bar.appendChild(ph);
        }
        var pos = document.createElement('span');
        pos.className = 'text-muted tabular-nums';
        pos.textContent = '本考点第 ' + (i + 1) + '/' + qs.length + ' 题';
        bar.appendChild(pos);
        if (i < qs.length - 1) {
          var next = document.createElement('a');
          next.className = '-my-2.5 inline-flex min-h-10 items-center whitespace-nowrap font-medium text-brand-700 hover:underline';
          next.href = '/q/' + qs[i + 1] + '/';
          next.textContent = '下一题 →';
          bar.appendChild(next);
        } else {
          var nh = document.createElement('span'); nh.className = 'text-muted'; nh.textContent = '已是最后一题';
          bar.appendChild(nh);
        }
        host.parentNode.insertBefore(bar, host.nextSibling);
        bindQNavKeys(i > 0 ? '/q/' + qs[i - 1] + '/' : '', i < qs.length - 1 ? '/q/' + qs[i + 1] + '/' : '');
        var kbd = document.createElement('span');
        kbd.className = 'hidden text-[12px] text-muted sm:inline';
        kbd.textContent = '← → 键可翻题';
        bar.appendChild(kbd);
      }).catch(function () { /* noop */ });
  }

  /* ---------- 考点页：我的进度 + 全站参照 头卡（复用 /api/kpmap，冷启动不渲染） ----------
     SSR 直出 #kp-mine 占位，BOOT_JS 按 tiku-kpcard[exam/subject/kp]（本函数写回的 [mine,wrong,weak]）或本页题 ∩ tiku-done 首帧显隐，
     此处只填内容不插节点；首次到达且已做题全在其他页时 BOOT 无从得知，退回此处晚显示，写回后下次首帧直出 */
  function initKpPageCard() {
    var m = /^\/kaoshi\/([^/]+)\/([^/]+)\/kp\/([^/]+)\/$/.exec(location.pathname);
    if (!m) return;
    var card = document.getElementById('kp-mine'); if (!card) return;
    var ckey = m[1] + '/' + m[2] + '/' + m[3];
    var hide = function () { card.classList.add('hidden'); card.classList.remove('flex'); writeKpCard(ckey, null); };
    var doneSet = {}; var wrongSet = {};
    store.readList('tiku-done').forEach(function (p) { var s = toSlug(p); if (s) doneSet[s] = 1; });
    store.readList('tiku-wrong').forEach(function (p) { var s = toSlug(p); if (s) wrongSet[s] = 1; });
    fetch('/api/kpmap?exam=' + encodeURIComponent(m[1]) + '&subject=' + encodeURIComponent(m[2]))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var it = (d.kps || []).filter(function (k) { return k.slug === m[3]; })[0];
        var qs = it ? (it.q || []) : [];
        var doneQs = qs.filter(function (s) { return doneSet[s]; });
        if (doneQs.length === 0) { hide(); return; }
        var ok = doneQs.filter(function (s) { return !wrongSet[s]; }).length;
        var myPct = Math.round(ok / doneQs.length * 100);
        var wrongQs = qs.filter(function (s) { return wrongSet[s]; });
        document.getElementById('kp-mine-d').textContent = String(doneQs.length);
        document.getElementById('kp-mine-t').textContent = String(qs.length);
        document.getElementById('kp-mine-p').textContent = String(myPct);
        /* 与科目页考点索引同口径（kpPersonalStats：已做 ≥3 且 <70%）；BOOT 按本页题预挂 ws-kpweak，此处按全考点定夺 */
        var weakTag = document.getElementById('kp-weak');
        var weak = doneQs.length >= WEAK_MIN_DONE && ok / doneQs.length < WEAK_ACC;
        weakTag.classList.toggle('hidden', !weak); weakTag.classList.toggle('inline-block', weak);
        var wa = document.getElementById('kp-mine-wrong');
        if (wrongQs.length > 0) {
          wa.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(shuffleSlugs(wrongQs.slice(0, 50)).join(','));
          wa.textContent = '连刷本考点错题（' + (wrongQs.length > 50 ? '随机 50/' + wrongQs.length : wrongQs.length) + ' 题）→';
          wa.classList.remove('hidden'); wa.classList.add('inline');
        } else {
          wa.parentNode.removeChild(wa);
        }
        var na = document.getElementById('kp-mine-new'); var acts = na.parentNode;
        var newQs = qs.filter(function (s) { return !doneSet[s]; });
        if (newQs.length > 0) {
          na.href = '/practice/?mode=slugs&slugs=' + encodeURIComponent(shuffleSlugs(newQs).slice(0, 50).join(','));
          na.textContent = '刷未做题（' + (newQs.length > 50 ? '随机 50/' + newQs.length : newQs.length) + ' 题）→';
        } else {
          acts.removeChild(na);
        }
        if (!acts.children.length) acts.parentNode.removeChild(acts);
        card.classList.remove('hidden'); card.classList.add('flex');
        writeKpCard(ckey, [1, wrongQs.length > 0 ? 1 : 0, weak ? 1 : 0]);
        /* 全站参照：已做题分片 qstats 聚合（attempts≥5 的题 ≥2 道才有数，对齐 R293 口径）；占位「全站正确率 …」原地改文案，样本不足明示 */
        var ref = document.getElementById('kp-mine-ref');
        var reqs = [];
        for (var i = 0; i < doneQs.length; i += 20) {
          reqs.push(fetch('/api/qstats?slugs=' + encodeURIComponent(doneQs.slice(i, i + 20).join(',')))
            .then(function (r) { return r.json(); })
            .then(function (dd) { return dd.items || []; })
            .catch(function () { return []; }));
        }
        Promise.all(reqs).then(function (parts) {
          var att = 0, cor = 0, n = 0;
          parts.forEach(function (items) {
            items.forEach(function (s) {
              if ((s.attempts || 0) < 5) return;
              att += s.attempts; cor += s.correct; n += 1;
            });
          });
          if (n < 2 || att === 0) { ref.textContent = '全站样本不足'; return; }
          var gp = Math.round(cor / att * 100);
          ref.textContent = '全站正确率 ' + gp + '%';
          var diff = myPct - gp;
          if (diff >= 10 || diff <= -10) {
            var tag = document.createElement('span');
            tag.className = 'ml-1.5 inline-block align-top rounded-full px-1.5 text-[11px] leading-5 font-medium ' +
              (diff >= 10 ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700');
            tag.textContent = diff >= 10 ? '领先' : '落后';
            ref.appendChild(tag);
          }
        });
      })
      .catch(hide);
  }

  /* ---------- 列表页行式题目：本地「已做」标记 ---------- */
  function initRowDone() {
    var rows = Array.prototype.slice.call(document.querySelectorAll('[data-qrow-slug]'));
    if (rows.length === 0) return;
    var done = store.readList('tiku-done');
    var wrong = store.readList('tiku-wrong');
    var fav = store.readList('tiku-fav');
    var notes = readNotes();
    var doneRows = [];
    rows.forEach(function (r) {
      var p = '/q/' + r.dataset.qrowSlug + '/';
      if (done.indexOf(p) >= 0) {
        var mark = r.querySelector('.js-qrow-done'); if (mark) mark.classList.remove('hidden');
        doneRows.push(r);
      }
      if (wrong.indexOf(p) >= 0) {
        var wm = r.querySelector('.js-qrow-wrong'); if (wm) wm.classList.remove('hidden');
      }
      if (fav.indexOf(p) >= 0) {
        var fm = r.querySelector('.js-qrow-fav'); if (fm) fm.classList.remove('hidden');
      }
      var n = notes[r.dataset.qrowSlug];
      if (n && n.t) {
        var nm = r.querySelector('.js-qrow-note'); if (nm) nm.classList.remove('hidden');
      }
    });
    /* 「只看未做」筛选：本页有已做行才渲染控件，偏好 tiku-hidedone 跨页保持 */
    var ssrBar = document.getElementById('qrow-tools');
    if (doneRows.length > 0) {
      var box = rows[0].parentNode;
      var bar, btn, tip;
      if (ssrBar) {
        /* 考点页 SSR 直出（BOOT_JS ws-rowdone 首帧控显）：原地填文案，不再晚插 48px 工具条 */
        bar = ssrBar; btn = document.getElementById('qrow-hidedone'); tip = document.getElementById('qrow-alldone');
        bar.classList.remove('hidden'); bar.classList.add('flex');
      } else {
        bar = document.createElement('div');
        bar.className = 'mb-2 flex flex-wrap items-center gap-2 text-[13px]';
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'inline-flex h-10 md:h-9 items-center rounded-full border border-line bg-white px-3.5 font-medium text-slate-600 hover:border-brand-600/50 hover:text-brand-700';
        tip = document.createElement('span');
        tip.className = 'hidden text-muted';
        tip.textContent = '本页题目已全部做过';
      }
      var pagePaper = document.getElementById('page-paper');
      var pagePaperHref = pagePaper ? pagePaper.getAttribute('href') : '';
      function apply(on) {
        doneRows.forEach(function (r) { r.classList.toggle('hidden', on); });
        if (pagePaper) {
          var left = on ? rows.filter(function (r) { return doneRows.indexOf(r) < 0; }) : [];
          pagePaper.setAttribute('href', left.length > 0 ? '/practice/?mode=slugs&slugs=' + left.map(function (r) { return r.dataset.qrowSlug; }).join(',') : pagePaperHref);
          pagePaper.textContent = left.length > 0 ? '连刷本页未做 ' + left.length + ' 题 →' : '连刷本页 →';
        }
        btn.textContent = on ? '显示全部（已隐藏 ' + doneRows.length + ' 题）' : '只看未做（本页已做 ' + doneRows.length + ' 题）';
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        tip.classList.toggle('hidden', !(on && doneRows.length === rows.length));
      }
      btn.addEventListener('click', function () {
        var on = btn.getAttribute('aria-pressed') !== 'true';
        try { if (on) localStorage.setItem('tiku-hidedone', '1'); else localStorage.removeItem('tiku-hidedone'); } catch (_) { /* noop */ }
        apply(on);
      });
      if (!ssrBar) {
        bar.appendChild(btn);
        bar.appendChild(tip);
        box.parentNode.insertBefore(bar, box);
      }
      var pref = false;
      try { pref = localStorage.getItem('tiku-hidedone') === '1'; } catch (_) { /* noop */ }
      apply(pref);
      var boot = document.getElementById('kp-hide0');
      if (boot) boot.parentNode.removeChild(boot);
    }
    /* 全站正确率注入（attempts≥5 显示 N%，<50% 加易错 chip）；qstats 上限 20 = 列表页页大小 */
    var slugs = rows.map(function (r) { return r.dataset.qrowSlug; }).slice(0, 20);
    fetch('/api/qstats?slugs=' + encodeURIComponent(slugs.join(',')))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var by = {};
        (d.items || []).forEach(function (it) { by[it.slug] = it; });
        rows.forEach(function (r) {
          var it = by[r.dataset.qrowSlug];
          if (!it || it.attempts < 5) return;
          var pct = Math.round(it.correct / it.attempts * 100);
          var rate = r.querySelector('.js-qrow-rate');
          if (rate) { rate.textContent = '正确率 ' + pct + '%'; rate.classList.remove('hidden'); rate.classList.add('max-sm:hidden'); }
          if (pct < 50) {
            var hard = r.querySelector('.js-qrow-hard'); if (hard) hard.classList.remove('hidden');
          }
        });
      }).catch(function () { /* noop */ });
  }

  /* ---------- 首页考试倒计时：天数客户端计算，避免 SSR 缓存过期 ---------- */
  function initCountdown() {
    var chips = Array.prototype.slice.call(document.querySelectorAll('.js-exam-cd'));
    chips.forEach(function (chip) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(chip.dataset.examDate || '');
      if (!m) return;
      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var target = new Date(+m[1], +m[2] - 1, +m[3]);
      var days = Math.round((target - today) / 86400000);
      /* 「已结束」芯片（无下一场时 data-exam-date 即已过的考期）由服务端 14 天窗口控制，客户端不隐藏 */
      if (days < 0) { if (!chip.dataset.examEnded) chip.hidden = true; return; }
      var d = chip.querySelector('.js-cd-days');
      if (days === 0) { if (d) d.parentNode.textContent = '今日开考'; }
      else if (d) { d.textContent = String(days); }
      chip.classList.remove('hidden'); chip.classList.add('inline-flex');
    });
  }

  /* ---------- 顶栏免责提示：可关闭（页脚声明常驻） ---------- */
  function initNote() {
    var note = document.getElementById('site-note'); if (!note) return;
    if (store.read('tiku-note-off', 'null') === 1) { note.remove(); return; }
    var close = document.getElementById('site-note-close');
    if (close) { close.addEventListener('click', function () { store.write('tiku-note-off', 1); note.remove(); }); }
  }

  /* ---------- 每日一练（/daily/） ---------- */
  function initDaily() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-daily-slug]'));
    if (items.length === 0) return;
    var done = store.readList('tiku-done');
    try { sessionStorage.setItem('tiku-daily-queue', JSON.stringify({ slugs: items.map(function (a) { return a.dataset.dailySlug; }) })); } catch (_) { /* noop */ }
    var CHECK = '<svg class="size-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/></svg>';
    var n = 0; var firstUndone = null;
    items.forEach(function (a) {
      var isDone = done.indexOf('/q/' + a.dataset.dailySlug + '/') >= 0;
      if (isDone) {
        n++;
        var num = a.querySelector('.js-daily-num');
        if (num) { num.className = 'js-daily-num mt-0.5 grid size-6 shrink-0 place-items-center rounded-full bg-emerald-600 text-white'; num.innerHTML = CHECK; }
        a.setAttribute('aria-label', '已完成');
      } else if (!firstUndone) { firstUndone = a; }
    });
    var prog = document.getElementById('daily-progress');
    if (prog && n > 0) {
      prog.classList.remove('hidden');
      var doneEl = document.getElementById('daily-done'); if (doneEl) doneEl.textContent = String(n);
      var bar = document.getElementById('daily-bar'); if (bar) bar.style.width = Math.round(n / items.length * 100) + '%';
    }
    var start = document.getElementById('daily-start');
    if (!start) return;
    /* 已交卷：本标签页会话（tiku-ws）→ 直回报告；仅历史有记录（换标签/隔日）→ 去练习历史看成绩 */
    var slugs = items.map(function (a) { return a.dataset.dailySlug; });
    var qIdx = start.href.indexOf('?');
    var wsSub = qIdx >= 0 ? readWs(start.href.slice(qIdx)) : null;
    var histHit = null;
    if (!(wsSub && wsSub.submitted)) {
      var hist = store.read('tiku-hist', '[]');
      if (Array.isArray(hist)) {
        for (var hi = 0; hi < hist.length; hi++) {
          var h = hist[hi];
          if (!h || (h.s || '').indexOf('每日一练') !== 0 || !Array.isArray(h.q) || h.q.length !== slugs.length) continue;
          var all = true;
          for (var si = 0; si < slugs.length; si++) { if (h.q.indexOf(slugs[si]) < 0) { all = false; break; } }
          if (all) { histHit = h; break; }
        }
      }
    }
    if (wsSub && wsSub.submitted) {
      start.textContent = '已交卷 · 回看报告 →';
    } else if (histHit) {
      start.href = '/my/#hist-h';
      start.textContent = '已交卷 ' + (histHit.ok || 0) + '/' + histHit.n + ' · 看成绩 →';
    } else if (n > 0) {
      if (firstUndone) { start.textContent = '继续做题（' + n + '/' + items.length + '）→'; }
      else { start.textContent = '已全部完成 · 再刷一遍 →'; }
    }
  }

  /* 到期错题（间隔复习）：距最后答错/复习 ≥ 当前轮次间隔（1/3/7 天，无时间戳的存量错题视为到期），最旧在前；顺带清理孤儿时间戳/轮次 */
  function wrongDue() {
    var wrongPaths = store.readList('tiku-wrong');
    var wt = store.read('tiku-wrongt', '{}');
    var wk = store.read('tiku-wrongk', '{}');
    var inWrong = {}; wrongPaths.forEach(function (p) { inWrong[p] = 1; });
    var dirty = false; var kDirty = false;
    Object.keys(wt).forEach(function (p) { if (!inWrong[p]) { delete wt[p]; dirty = true; } });
    Object.keys(wk).forEach(function (p) { if (!inWrong[p]) { delete wk[p]; kDirty = true; } });
    if (dirty) store.write('tiku-wrongt', wt);
    if (kDirty) store.write('tiku-wrongk', wk);
    var due = wrongPaths.filter(function (p) { return reviewDue(wt[p], wk[p]); });
    due.sort(function (a, b) { return (wt[a] || 0) - (wt[b] || 0); });
    return due;
  }

  /* /my/ 分区导航：有数据才显示的卡解除对应 chip 的 hidden（成就 chip 靠 BOOT_JS ws-days 首帧前已显示，这里只兼容无标记态） */
  function showNavChip(id) {
    var nav = document.getElementById('my-nav');
    if (!nav) return;
    var a = nav.querySelector('a[data-nav="' + id + '"]');
    if (!a) return;
    a.hidden = false;
    if (a.classList.contains('hidden')) { a.classList.remove('hidden'); a.classList.add('inline-flex'); }
  }

  /* 考点个人统计（科目页 /api/kpmap × tiku-done × tiku-wrong）：已做/错题本命中/正确率。阈值（WEAK_MIN_DONE/WEAK_ACC）与首页弱项卡、/my/ 掌握度一致，但样本不同：这里按 slug 取该科目全部 done，首页/掌握度按考点名取最近 100 条 done，done >100 时两处「薄弱」结论可不同 */
  function kpPersonalStats(kps) {
    var done = {}; store.readList('tiku-done').forEach(function (p) { var s = toSlug(p); if (s) done[s] = 1; });
    var wrong = {}; store.readList('tiku-wrong').forEach(function (p) { var s = toSlug(p); if (s) wrong[s] = 1; });
    var out = {};
    (kps || []).forEach(function (it) {
      var st = { total: 0, done: 0, wrong: 0, acc: 1, undone: [] };
      (it.q || []).forEach(function (s) {
        st.total++;
        if (done[s]) { st.done++; if (wrong[s]) st.wrong++; } else st.undone.push(s);
      });
      if (st.done > 0) st.acc = 1 - st.wrong / st.done;
      st.weak = st.done >= WEAK_MIN_DONE && st.acc < WEAK_ACC;
      out[it.slug] = st;
    });
    return out;
  }

  /* 往期七天（每日一练页）：用 tiku-hist 点亮已完成日期与得分，记录不上传 */
  function initDailyHistory() {
    var cards = document.querySelectorAll('[data-daily-date]');
    if (cards.length === 0) return;
    var hist = store.read('tiku-hist', '[]');
    if (!Array.isArray(hist)) hist = [];
    var grid = document.querySelector('[data-daily-exam]');
    var examName = grid ? grid.getAttribute('data-daily-exam') : '';
    var best = {};
    hist.forEach(function (h) {
      var m = /^每日一练 · (\d{4}-\d{2}-\d{2})(?: · (.+))?$/.exec(h && h.s || '');
      if (!m || !h.n || (m[2] || '') !== examName) return;
      var pct = Math.round(h.ok / h.n * 100);
      if (!(m[1] in best) || pct > best[m[1]]) best[m[1]] = pct;
    });
    Array.prototype.forEach.call(cards, function (card) {
      var d = card.getAttribute('data-daily-date');
      var st = card.querySelector('.js-daily-st');
      if (!st || !(d in best)) return;
      st.textContent = '已完成 · ' + best[d] + ' 分';
      st.className = 'js-daily-st mt-1.5 block text-[13px] font-medium text-emerald-700';
    });
  }

  /* 模考页考试线筛选 chips：默认选中 tiku-exam 记忆，点选只显该线科目并写回记忆 */
  function initMockExamFilter() {
    var chips = Array.prototype.slice.call(document.querySelectorAll('[data-mock-exam-chip]'));
    if (chips.length === 0) return;
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-mock-exam]'));
    var count = document.getElementById('mock-count');
    function apply(sel) {
      /* 首帧由 BOOT_JS html[data-exam] + 索引页内联 <style> 决定卡片显隐；此处同步该标记，避免「全部」后 CSS 仍隐藏 */
      if (sel) document.documentElement.dataset.exam = sel; else delete document.documentElement.dataset.exam;
      chips.forEach(function (b) {
        var on = b.dataset.mockExamChip === sel;
        b.className = 'inline-flex h-10 md:h-9 items-center rounded-full border px-3 text-sm ' +
          (on ? 'border-brand-700 bg-brand-700 font-medium text-white' : 'border-line bg-white text-slate-600 hover:bg-brand-50');
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var vis = 0; var papers = 0;
      cards.forEach(function (c) {
        var show = !sel || c.dataset.mockExam === sel;
        c.hidden = !show;
        if (show) { if (!c.hasAttribute('data-mock-line')) vis += 1; papers += c.querySelectorAll('[data-mock-s]').length; }
      });
      if (count) count.textContent = '共 ' + papers + ' 套固定卷 · ' + vis + ' 个科目';
    }
    chips.forEach(function (b) {
      b.addEventListener('click', function () {
        var sel = b.dataset.mockExamChip;
        apply(sel);
        if (sel) store.write('tiku-exam', sel);
      });
    });
    var fromUrl = new URLSearchParams(location.search).get('exam');
    if (fromUrl && chips.some(function (b) { return b.dataset.mockExamChip === fromUrl; })) {
      apply(fromUrl);
      store.write('tiku-exam', fromUrl);
      return;
    }
    var saved = store.read('tiku-exam', 'null');
    apply(chips.some(function (b) { return b.dataset.mockExamChip === saved; }) ? saved : '');
  }

  /* ---------- 搜索历史（tiku-kw：最近搜索词数组，最近优先去重，上限 8 条，仅本地） ---------- */
  function initSearchHist() {
    if (location.pathname !== '/search/') return;
    var KEY = 'tiku-kw';
    var list = store.readList(KEY).filter(function (s) { return typeof s === 'string' && s.length > 0; });
    var input = document.querySelector('input[name="kw"]');
    var kw = input ? input.value.trim() : '';
    if (kw.length >= 2) {
      list = [kw].concat(list.filter(function (s) { return s !== kw; })).slice(0, 8);
      store.write(KEY, list);
    }
    var box = document.getElementById('kw-hist');
    if (!box || list.length === 0) return;
    var head = document.createElement('div');
    head.className = 'flex items-center justify-between';
    var h = document.createElement('h2');
    h.className = 'text-sm font-semibold text-muted';
    h.textContent = '最近搜索';
    var clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'px-2 py-1 text-[13px] text-muted hover:text-ink';
    clear.textContent = '清除';
    clear.setAttribute('aria-label', '清除最近搜索记录');
    clear.addEventListener('click', function () {
      try { localStorage.removeItem(KEY); } catch (_) { /* noop */ }
      box.hidden = true;
    });
    head.appendChild(h); head.appendChild(clear);
    var wrap = document.createElement('div');
    wrap.className = 'mt-2.5 flex flex-wrap gap-2';
    list.forEach(function (k) {
      var a = document.createElement('a');
      a.href = '/search/?kw=' + encodeURIComponent(k);
      a.className = 'inline-flex h-10 max-w-full items-center truncate rounded-full border border-line bg-white px-3.5 text-[13px] text-slate-600 hover:border-brand-600/40 hover:text-brand-700';
      a.textContent = k;
      wrap.appendChild(a);
    });
    box.appendChild(head); box.appendChild(wrap);
    box.hidden = false;
  }

  /* ---------- 搜索联想（/api/suggest 去抖下拉，键盘可达，纯展示零存储） ---------- */
  function initSearchSuggest() {
    if (location.pathname !== '/search/' && location.pathname !== '/') return;
    var input = document.querySelector('form[role="search"] input[name="kw"]');
    if (!input) return;
    var wrap = input.parentElement;
    if (!wrap) return;
    wrap.classList.add('relative');
    var box = document.createElement('ul');
    box.id = 'kw-suggest';
    box.setAttribute('role', 'listbox');
    box.setAttribute('aria-label', '搜索联想');
    box.className = 'absolute left-0 right-0 top-full z-30 mt-1 overflow-hidden rounded-lg border border-line bg-white shadow-lg';
    box.hidden = true;
    wrap.appendChild(box);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', 'kw-suggest');
    input.setAttribute('autocomplete', 'off');
    var timer = 0, seq = 0, active = -1, opts = [];
    function close() {
      box.hidden = true;
      box.textContent = '';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1; opts = [];
    }
    function highlight(i) {
      opts.forEach(function (li, j) {
        li.classList.toggle('bg-brand-50', j === i);
        li.setAttribute('aria-selected', j === i ? 'true' : 'false');
        if (j === i) input.setAttribute('aria-activedescendant', li.id);
      });
      if (i < 0) input.removeAttribute('aria-activedescendant');
      active = i;
    }
    function render(cats, items) {
      close();
      if (cats.length === 0 && items.length === 0) return;
      cats.forEach(function (ct) {
        if (!ct || typeof ct.href !== 'string' || typeof ct.name !== 'string' || ct.href.charAt(0) !== '/') return;
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        li.className = 'cursor-pointer border-b border-line/60 bg-brand-50/40 px-3 py-2.5 text-[13px] last:border-b-0 hover:bg-brand-50';
        var name = document.createElement('span');
        name.className = 'block truncate font-medium text-brand-700';
        name.textContent = '\ud83d\udcc2 ' + ct.name;
        li.appendChild(name);
        var meta = document.createElement('span');
        meta.className = 'mt-0.5 block text-[12px] text-muted';
        meta.textContent = (typeof ct.sub === 'string' && ct.sub ? ct.sub + ' \u00b7 ' : '') + (typeof ct.n === 'number' ? ct.n + ' \u9898' : '\u5206\u7c7b\u76f4\u8fbe');
        li.appendChild(meta);
        li.addEventListener('mousedown', function (e) {
          e.preventDefault();
          location.href = ct.href;
        });
        li.id = 'kw-sug-' + opts.length;
        box.appendChild(li);
        opts.push(li);
      });
      items.forEach(function (it) {
        if (!it || typeof it.slug !== 'string' || typeof it.stem !== 'string') return;
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        li.className = 'cursor-pointer border-b border-line/60 px-3 py-2.5 text-[13px] last:border-b-0 hover:bg-brand-50';
        var stem = document.createElement('span');
        stem.className = 'block truncate text-ink';
        stem.textContent = it.stem;
        li.appendChild(stem);
        if (typeof it.subject === 'string' && it.subject) {
          var sub = document.createElement('span');
          sub.className = 'mt-0.5 block text-[12px] text-muted';
          sub.textContent = it.subject;
          li.appendChild(sub);
        }
        li.addEventListener('mousedown', function (e) {
          e.preventDefault();
          location.href = '/q/' + encodeURIComponent(it.slug) + '/';
        });
        li.id = 'kw-sug-' + opts.length;
        box.appendChild(li);
        opts.push(li);
      });
      if (opts.length === 0) return;
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var kw = input.value.trim();
      if (kw.replace(/\s+/g, '').length < 2) { close(); return; }
      timer = setTimeout(function () {
        var my = ++seq;
        fetch('/api/suggest?kw=' + encodeURIComponent(kw))
          .then(function (r) { return r.ok ? r.json() : { items: [] }; })
          .then(function (d) {
            if (my !== seq) return;
            render(Array.isArray(d.cats) ? d.cats : [], Array.isArray(d.items) ? d.items : []);
          })
          .catch(function () { if (my === seq) close(); });
      }, 250);
    });
    input.addEventListener('keydown', function (e) {
      if (box.hidden || opts.length === 0) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight((active + 1) % opts.length); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight((active - 1 + opts.length) % opts.length); }
      else if (e.key === 'Enter' && active >= 0) {
        e.preventDefault();
        var evt = opts[active];
        if (evt) evt.dispatchEvent(new MouseEvent('mousedown'));
      } else if (e.key === 'Escape') { close(); }
    });
    input.addEventListener('blur', function () { setTimeout(close, 150); });
  }

  /* 收到新回复红点：非 /my/ 页对比本机评论的最新回复数与已读基线（tiku-cseen），30 分钟节流 */
  function initReplyDot() {
    if (location.pathname === '/my/') return;
    function showDot() {
      document.querySelectorAll('nav a[href="/my/"]').forEach(function (a) {
        if (a.querySelector('.js-reply-dot')) return;
        var dot = document.createElement('span');
        dot.className = 'js-reply-dot absolute right-0.5 top-1.5 size-2 rounded-full bg-red-500 md:top-2.5';
        dot.setAttribute('aria-label', '有新回复');
        a.classList.add('relative');
        a.appendChild(dot);
      });
    }
    var flag = null;
    try { flag = localStorage.getItem('tiku-cnew'); } catch (_) { /* noop */ }
    if (flag === '1') showDot();
    var tok; try { tok = JSON.parse(localStorage.getItem('tiku-ctok') || '{}'); } catch (_) { tok = {}; }
    if (!tok || typeof tok !== 'object') tok = {};
    var ids = Object.keys(tok).filter(function (k) { return /^\d+$/.test(k); });
    if (ids.length === 0) return;
    var last = 0;
    try { last = parseInt(localStorage.getItem('tiku-cchk') || '0', 10) || 0; } catch (_) { /* noop */ }
    if (Date.now() - last < 30 * 60e3) return;
    try { localStorage.setItem('tiku-cchk', String(Date.now())); } catch (_) { /* noop */ }
    ids.sort(function (a, b) { return b - a; });
    fetch('/api/my-comments?ids=' + ids.slice(0, 50).join(','))
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (d) {
        var seen = store.read('tiku-cseen', '{}');
        if (!seen || typeof seen !== 'object') seen = {};
        var hasNew = ((d && d.items) || []).some(function (it) { return it.pid === 0 && (it.replies || 0) > (seen[it.id] || 0); });
        try { localStorage.setItem('tiku-cnew', hasNew ? '1' : '0'); } catch (_) { /* noop */ }
        if (hasNew) showDot();
      }).catch(function () { /* noop */ });
  }

  /* 最近浏览：/q/ 页记录 tiku-view=[{s,t,ts}]（去重置顶、上限 30），/my/「最近浏览」区回访，仅本地 */
  /* 题页所属考试线：面包屑首链 /kaoshi/{exam}/（SSR 直出，与 JSON-LD 同源） */
  function qPageExam() {
    var a = document.querySelector('nav[aria-label="面包屑"] a[href^="/kaoshi/"]');
    var m = a ? /^\/kaoshi\/([\w-]{1,40})\/$/.exec(a.getAttribute('href') || '') : null;
    return m ? m[1] : null;
  }

  /* 题页「上次看到」记忆（首页续练 / 底栏「练习」回退目标）；bfcache 恢复回本题时重写，与 reload 同结果 */
  function writeLastQ() {
    if (!document.getElementById('options')) return;
    try {
      var subjPill = document.querySelector('main .rounded-full.bg-slate-100');
      store.write('tiku-last', { p: location.pathname, s: subjPill ? subjPill.textContent : '' });
    } catch (_) { /* noop */ }
  }

  function recordView() {
    var slug = toSlug(location.pathname);
    var stem = document.getElementById('stem');
    if (!slug || !stem || !document.getElementById('options')) return;
    var t = (stem.textContent || '').trim().slice(0, 40);
    if (!t) return;
    var list = store.readList('tiku-view').filter(function (v) {
      return v && typeof v.s === 'string' && v.s !== slug;
    });
    list.unshift({ s: slug, t: t, ts: Math.floor(Date.now() / 1000) });
    store.write('tiku-view', list.slice(0, 30));
  }

  function viewAgo(ts) {
    var d = Math.max(0, Math.floor(Date.now() / 1000) - ts);
    if (d < 3600) return Math.max(1, Math.floor(d / 60)) + ' 分钟前';
    if (d < 86400) return Math.floor(d / 3600) + ' 小时前';
    return Math.floor(d / 86400) + ' 天前';
  }

  function initRecentView() {
    var sec = document.getElementById('view-sec');
    var ul = document.getElementById('view-list');
    var clear = document.getElementById('view-clear');
    if (!sec || !ul || !clear) return;
    var list = store.readList('tiku-view').filter(function (v) {
      return v && typeof v.s === 'string' && typeof v.t === 'string' && typeof v.ts === 'number';
    }).slice(0, 10);
    if (list.length === 0) return;
    list.forEach(function (v) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '/q/' + encodeURIComponent(v.s) + '/';
      a.className = 'flex items-center justify-between gap-3 rounded-xl border border-line bg-white px-4 py-3 hover:border-brand-600/40';
      var stem = document.createElement('span');
      stem.className = 'truncate text-sm text-ink';
      stem.textContent = v.t;
      var when = document.createElement('span');
      when.className = 'shrink-0 text-[12px] text-muted';
      when.textContent = viewAgo(v.ts);
      a.appendChild(stem);
      a.appendChild(when);
      li.appendChild(a);
      ul.appendChild(li);
    });
    sec.hidden = false;
    showNavChip('view-sec');
    clear.addEventListener('click', function () {
      if (!confirm('清空最近浏览记录？')) return;
      store.write('tiku-view', []);
      sec.hidden = true;
      var nav = document.getElementById('my-nav');
      var chip = nav && nav.querySelector('a[data-nav="view-sec"]');
      if (chip) chip.hidden = true;
    });
  }

  /* 我的纠错：tiku-fbk 记录提交过的纠错 {s,k,d,ts}，新在前 cap 30，随云同步 */
  var FBK_LABEL = { answer: '答案有误', stem: '题干或选项有误', explain: '解析有误', other: '其他' };
  function saveFbk(slug, kind, detail) {
    var list = store.readList('tiku-fbk');
    list.unshift({ s: String(slug), k: FBK_LABEL[kind] ? kind : 'other', d: String(detail || '').slice(0, 60), ts: Date.now() });
    store.write('tiku-fbk', list.slice(0, 30));
  }
  function initMyFbk() {
    var sec = document.getElementById('fbk-sec');
    var ul = document.getElementById('fbk-list');
    var clear = document.getElementById('fbk-clear');
    if (!sec || !ul || !clear) return;
    var list = store.readList('tiku-fbk').filter(function (v) {
      return v && typeof v.s === 'string' && typeof v.k === 'string' && typeof v.ts === 'number';
    }).slice(0, 10);
    if (list.length === 0) return;
    var fbkTitleEls = {};
    list.forEach(function (v) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '/q/' + encodeURIComponent(v.s) + '/';
      a.className = 'block rounded-xl border border-line bg-white px-4 py-3 hover:border-brand-600/40';
      var top = document.createElement('div');
      top.className = 'flex items-center justify-between gap-3';
      var t = document.createElement('span');
      t.className = 'truncate text-sm font-medium text-ink';
      t.textContent = (FBK_LABEL[v.k] || '其他') + ' · ' + v.s;
      if (!fbkTitleEls[v.s]) fbkTitleEls[v.s] = [];
      fbkTitleEls[v.s].push({ el: t, k: v.k });
      var when = document.createElement('span');
      when.className = 'shrink-0 text-[12px] text-muted';
      when.textContent = viewAgo(v.ts);
      top.appendChild(t);
      top.appendChild(when);
      a.appendChild(top);
      if (typeof v.d === 'string' && v.d) {
        var d = document.createElement('p');
        d.className = 'mt-1 truncate text-[13px] text-muted';
        d.textContent = v.d;
        a.appendChild(d);
      }
      li.appendChild(a);
      ul.appendChild(li);
    });
    sec.hidden = false;
    showNavChip('fbk-sec');
    var fbkSlugs = Object.keys(fbkTitleEls);
    if (fbkSlugs.length > 0) {
      fetch('/api/questions?slugs=' + encodeURIComponent(fbkSlugs.join(',')))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          (d.items || []).forEach(function (q) {
            if (!q || typeof q.slug !== 'string' || typeof q.stem !== 'string' || !q.stem) return;
            var stem = q.stem.length > 60 ? q.stem.slice(0, 60) + '…' : q.stem;
            (fbkTitleEls[q.slug] || []).forEach(function (e) {
              e.el.textContent = (FBK_LABEL[e.k] || '其他') + ' · ' + stem;
            });
          });
        })
        .catch(function () { /* 拉题干失败保持 slug 展示 */ });
    }
    clear.addEventListener('click', function () {
      if (!confirm('清空纠错记录？（不影响已提交给运营的纠错）')) return;
      store.write('tiku-fbk', []);
      sec.hidden = true;
      var nav = document.getElementById('my-nav');
      var chip = nav && nav.querySelector('a[data-nav="fbk-sec"]');
      if (chip) chip.hidden = true;
    });
  }

  /* AI 答疑历史：/my/「我的 AI 答疑」区（tiku-ai 最近 10 条，直达题目页） */
  function initMyAi() {
    var sec = document.getElementById('ai-sec');
    var ul = document.getElementById('ai-list');
    var clear = document.getElementById('ai-clear');
    if (!sec || !ul || !clear) return;
    var list = store.readList('tiku-ai').filter(function (v) {
      return v && typeof v.s === 'string' && typeof v.q === 'string' && typeof v.a === 'string' && typeof v.ts === 'number';
    }).slice(0, 10);
    var airH = document.getElementById('air-h');
    var airUl = document.getElementById('air-list');
    var airs = store.readList('tiku-air').filter(function (v) {
      return v && typeof v.t === 'string' && typeof v.a === 'string' && typeof v.ts === 'number';
    }).slice(0, 5);
    if (list.length === 0 && airs.length === 0) return;
    list.forEach(function (v) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '/q/' + encodeURIComponent(v.s) + '/';
      a.className = 'block rounded-xl border border-line bg-white px-4 py-3 hover:border-brand-600/40';
      var top = document.createElement('div');
      top.className = 'flex items-center justify-between gap-3';
      var q = document.createElement('span');
      q.className = 'truncate text-sm font-medium text-ink';
      q.textContent = '问：' + v.q;
      var when = document.createElement('span');
      when.className = 'shrink-0 text-[12px] text-muted';
      when.textContent = viewAgo(v.ts);
      top.appendChild(q);
      top.appendChild(when);
      var ans = document.createElement('p');
      ans.className = 'mt-1 truncate text-[13px] text-muted';
      ans.textContent = v.a;
      a.appendChild(top);
      a.appendChild(ans);
      li.appendChild(a);
      ul.appendChild(li);
    });
    if (airH && airUl && airs.length > 0) {
      airH.hidden = false;
      airs.forEach(function (v) {
        var li = document.createElement('li');
        li.className = 'rounded-xl border border-line bg-white px-4 py-3';
        var det = document.createElement('details');
        var sum = document.createElement('summary');
        sum.className = 'cursor-pointer list-none [&::-webkit-details-marker]:hidden';
        var top = document.createElement('div');
        top.className = 'flex items-center justify-between gap-3';
        var t = document.createElement('span');
        t.className = 'truncate text-sm font-medium text-ink';
        t.textContent = v.t + (typeof v.n === 'number' && typeof v.ok === 'number' && v.n > 0 ? ' · 答对 ' + v.ok + '/' + v.n : '');
        var when = document.createElement('span');
        when.className = 'shrink-0 text-[12px] text-muted';
        when.textContent = viewAgo(v.ts);
        top.appendChild(t);
        top.appendChild(when);
        var ans = document.createElement('p');
        ans.className = 'mt-1 truncate text-[13px] text-muted';
        ans.textContent = v.a + '（点击展开）';
        sum.appendChild(top);
        sum.appendChild(ans);
        var full = document.createElement('p');
        full.className = 'mt-2 whitespace-pre-line text-[13px] leading-relaxed text-ink';
        full.textContent = v.a;
        det.appendChild(sum);
        det.appendChild(full);
        det.addEventListener('toggle', function () { ans.hidden = det.open; });
        li.appendChild(det);
        airUl.appendChild(li);
      });
    }
    sec.hidden = false;
    showNavChip('ai-sec');
    clear.addEventListener('click', function () {
      if (!confirm('清空 AI 答疑与报告点评记录？')) return;
      store.write('tiku-ai', []);
      store.write('tiku-air', []);
      sec.hidden = true;
      var nav = document.getElementById('my-nav');
      var chip = nav && nav.querySelector('a[data-nav="ai-sec"]');
      if (chip) chip.hidden = true;
    });
  }

  /* 考点关注：考点页「☆ 关注本考点」toggle（tiku-kpfav 去重置顶上限 30，纯本地） */
  function readKpFav() {
    return store.readList('tiku-kpfav').filter(function (v) {
      return v && typeof v.e === 'string' && typeof v.s === 'string' && typeof v.k === 'string' && typeof v.n === 'string';
    });
  }

  function initKpFollow() {
    var m = /^\/kaoshi\/([^/]+)\/([^/]+)\/kp\/([^/]+)\/$/.exec(location.pathname);
    if (!m) return;
    var btn = document.getElementById('kp-fav'); if (!btn) return;
    var name = (btn.previousSibling && btn.previousSibling.textContent || '').trim(); if (!name) return;
    var isFav = function () {
      return readKpFav().some(function (v) { return v.e === m[1] && v.s === m[2] && v.k === m[3]; });
    };
    function paint() {
      var on = isFav();
      document.documentElement.classList.toggle('ws-kpfon', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    paint();
    btn.addEventListener('click', function () {
      var list = readKpFav().filter(function (v) { return !(v.e === m[1] && v.s === m[2] && v.k === m[3]); });
      if (!isFav()) {
        list.unshift({ e: m[1], s: m[2], k: m[3], n: name.slice(0, 40), ts: Math.floor(Date.now() / 1000) });
      }
      store.write('tiku-kpfav', list.slice(0, 30));
      paint();
    });
  }

  /* 首页快捷卡芯片：与容器同高（border-box）、上限 14rem 截断（块级 flex 项才能 text-overflow），焦点环内收避免被横滑容器裁掉 */
  var HOME_CHIP_CLASS = 'block h-10 max-w-56 shrink-0 truncate rounded-full border border-line bg-white px-3 text-[13px] leading-[38px] text-slate-600 hover:border-brand-600/40 hover:text-brand-700 focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-brand-600 md:h-8 md:leading-[30px]';

  /* 首页关注考点快捷卡：最近关注前 4 个直达考点页（无关注不渲染） */
  function initHomeKpFav() {
    var card = document.getElementById('kpfav-card');
    var box = document.getElementById('kpfav-chips');
    if (!card || !box) return;
    var list = readKpFav();
    if (list.length === 0) { card.hidden = true; return; }
    list.slice(0, 4).forEach(function (v) {
      var a = document.createElement('a');
      a.href = '/kaoshi/' + encodeURIComponent(v.e) + '/' + encodeURIComponent(v.s) + '/kp/' + encodeURIComponent(v.k) + '/';
      a.className = HOME_CHIP_CLASS;
      a.textContent = v.n;
      box.appendChild(a);
    });
    card.classList.remove('hidden');
    card.classList.add('flex');
  }

  /* 首页最近浏览快捷卡：最近看过前 4 题直达题目页（无记录不渲染） */
  function initHomeRecentView() {
    var card = document.getElementById('rview-card');
    var box = document.getElementById('rview-chips');
    if (!card || !box) return;
    var list = store.readList('tiku-view').filter(function (v) {
      return v && typeof v.s === 'string' && typeof v.t === 'string' && typeof v.ts === 'number';
    });
    if (list.length === 0) { card.hidden = true; return; }
    list.slice(0, 4).forEach(function (v) {
      var a = document.createElement('a');
      a.href = '/q/' + encodeURIComponent(v.s) + '/';
      a.className = HOME_CHIP_CLASS;
      a.textContent = v.t;
      box.appendChild(a);
    });
    card.classList.remove('hidden');
    card.classList.add('flex');
  }

  /* /my/ 关注的考点：直达 + 随机刷 10 题 + 取消关注（无数据不渲染） */
  function initKpFavList() {
    var sec = document.getElementById('kpfav-sec');
    var ul = document.getElementById('kpfav-list');
    if (!sec || !ul) return;
    var list = readKpFav();
    if (list.length === 0) return;
    list.forEach(function (v) {
      var li = document.createElement('li');
      li.className = 'flex items-center gap-3 rounded-xl border border-line bg-white px-4 py-3';
      var a = document.createElement('a');
      a.href = '/kaoshi/' + encodeURIComponent(v.e) + '/' + encodeURIComponent(v.s) + '/kp/' + encodeURIComponent(v.k) + '/';
      a.className = 'min-w-0 flex-1 hover:text-brand-700';
      var nm = document.createElement('p');
      nm.className = 'truncate text-sm font-medium text-ink';
      nm.textContent = v.n;
      a.appendChild(nm);
      var meta = document.createElement('p');
      meta.className = 'js-kpfav-meta truncate text-[12px] tabular-nums text-muted';
      meta.textContent = '已做 –/– 题';
      meta.dataset.kpfav = v.e + '/' + v.s + '/' + v.k;
      a.appendChild(meta);
      li.appendChild(a);
      var go = document.createElement('a');
      go.href = '/practice/?mode=custom&exam=' + encodeURIComponent(v.e) + '&subject=' + encodeURIComponent(v.s) + '&kp=' + encodeURIComponent(v.k) + '&n=10';
      go.className = 'shrink-0 -my-2.5 inline-flex min-h-10 items-center text-[13px] font-medium text-brand-700 hover:underline';
      go.textContent = '随机刷 10 题 →';
      li.appendChild(go);
      var del = document.createElement('button');
      del.type = 'button';
      del.className = 'shrink-0 -my-2.5 -mx-2 grid size-10 place-items-center rounded-lg text-sm text-muted hover:bg-slate-100 hover:text-red-600';
      del.textContent = '✕';
      del.setAttribute('aria-label', '取消关注 ' + v.n);
      del.addEventListener('click', function () {
        store.write('tiku-kpfav', readKpFav().filter(function (x) { return !(x.e === v.e && x.s === v.s && x.k === v.k); }));
        li.remove();
        if (!ul.querySelector('li')) {
          sec.hidden = true;
          var nav = document.getElementById('my-nav');
          var chip = nav && nav.querySelector('a[data-nav="kpfav-sec"]');
          if (chip) chip.hidden = true;
        }
      });
      li.appendChild(del);
      ul.appendChild(li);
    });
    sec.hidden = false;
    showNavChip('kpfav-sec');
    /* 进度行：首帧「已做 –/– 题」占位定高，按 exam+subject 去重批量拉 kpmap，命中只改文案（未命中保留占位，几何恒定） */
    var doneSet = {}; var wrongSet = {};
    store.readList('tiku-done').forEach(function (p) { var s = toSlug(p); if (s) doneSet[s] = 1; });
    store.readList('tiku-wrong').forEach(function (p) { var s = toSlug(p); if (s) wrongSet[s] = 1; });
    var pairs = {};
    list.forEach(function (v) { pairs[v.e + '/' + v.s] = { e: v.e, s: v.s }; });
    Object.keys(pairs).forEach(function (pk) {
      var pr = pairs[pk];
      fetch('/api/kpmap?exam=' + encodeURIComponent(pr.e) + '&subject=' + encodeURIComponent(pr.s))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          (d.kps || []).forEach(function (k) {
            var meta = ul.querySelector('.js-kpfav-meta[data-kpfav="' + pr.e + '/' + pr.s + '/' + k.slug + '"]');
            if (!meta) return;
            var qs = k.q || [];
            if (qs.length === 0) return;
            var doneQs = qs.filter(function (s) { return doneSet[s]; });
            var txt = '已做 ' + doneQs.length + '/' + qs.length + ' 题';
            if (doneQs.length > 0) {
              var ok = doneQs.filter(function (s) { return !wrongSet[s]; }).length;
              txt += ' · 正确率 ' + Math.round(ok / doneQs.length * 100) + '%';
            }
            meta.textContent = txt;
          });
        })
        .catch(function () {});
    });
  }

  /* 待复习错题数徽标：非 /my/ 页在移动端底部导航「我的」上显示到期错题数（间隔复习回访钩子，纯本地） */
  function initDueBadge() {
    if (location.pathname === '/my/') return;
    var n = wrongDue().length;
    if (!n) return;
    document.querySelectorAll('nav[aria-label="底部导航"] a[href="/my/"]').forEach(function (a) {
      if (a.querySelector('.js-due-badge')) return;
      var b = document.createElement('span');
      b.className = 'js-due-badge absolute right-1 top-0.5 min-w-4 rounded-full bg-amber-700 px-1 text-center text-[10px] font-semibold leading-4 text-white';
      b.textContent = n > 99 ? '99+' : String(n);
      b.setAttribute('aria-label', '待复习错题 ' + n + ' 题');
      a.classList.add('relative');
      a.appendChild(b);
    });
  }

  /* 每日一练打卡提醒点：做过每日一练且今日未做时，底部导航「每日」显示提醒圆点（纯本地） */
  function initDailyDot() {
    if (location.pathname.indexOf('/daily/') === 0) return;
    var hist = store.read('tiku-hist', '[]');
    if (!Array.isArray(hist)) return;
    var todayIso = localDay(new Date());
    var any = false; var today = false;
    hist.forEach(function (h) {
      if (!h || typeof h.s !== 'string' || h.s.indexOf('每日一练 · ') !== 0) return;
      any = true;
      if (h.s.indexOf('每日一练 · ' + todayIso) === 0) today = true;
    });
    if (!any || today) return;
    document.querySelectorAll('nav[aria-label="底部导航"] a[href="/daily/"]').forEach(function (a) {
      if (a.querySelector('.js-daily-dot')) return;
      var b = document.createElement('span');
      b.className = 'js-daily-dot absolute right-3 top-1 size-2 rounded-full bg-amber-500';
      b.setAttribute('aria-label', '今日每日一练未完成');
      a.classList.add('relative');
      a.appendChild(b);
    });
  }

  /* 每周模考提醒点：参加过每周模考且本周未参加时，底部导航「模考」显示提醒圆点（纯本地） */
  function initMockDot() {
    if (location.pathname.indexOf('/mock/') === 0) return;
    var hist = store.read('tiku-hist', '[]');
    if (!Array.isArray(hist)) return;
    var tag = '每周模考（' + curWeekIso() + '）';
    var any = false; var week = false;
    hist.forEach(function (h) {
      if (!h || typeof h.s !== 'string' || h.s.indexOf('每周模考（') === -1) return;
      any = true;
      if (h.s.indexOf(tag) !== -1) week = true;
    });
    if (!any || week) return;
    document.querySelectorAll('nav[aria-label="底部导航"] a[href="/mock/"]').forEach(function (a) {
      if (a.querySelector('.js-mock-dot')) return;
      var b = document.createElement('span');
      b.className = 'js-mock-dot absolute right-3 top-1 size-2 rounded-full bg-amber-500';
      b.setAttribute('aria-label', '本周模考未参加');
      a.classList.add('relative');
      a.appendChild(b);
    });
  }

  /* 面包屑在窄屏折成多行时，相邻行链接的 tap-y 40px 命中区互相覆盖（后者盖住前者文字下半），
     多行即撤销 tap-y 回到行内文本链接口径（单行保留）；行数按首末 li 的 top 判 */
  function initCrumbTap() {
    var nav = document.querySelector('nav[aria-label="面包屑"]'); if (!nav) return;
    var links = nav.querySelectorAll('a.tap-y'); if (links.length === 0) return;
    var lis = nav.querySelectorAll('li'); if (lis.length === 0) return;
    var first = lis[0].getBoundingClientRect().top;
    var last = lis[lis.length - 1].getBoundingClientRect().top;
    if (last - first < 4) return;
    links.forEach(function (a) { a.classList.remove('tap-y'); });
  }

  /* 打印卷解析区逐题注入「我的笔记」（tiku-note 本地笔记，随纸面打印，无笔记不渲染） */
  function initPrintNotes() {
    if (location.pathname !== '/print/') return;
    var lis = document.querySelectorAll('li[data-note-slug]'); if (lis.length === 0) return;
    var notes = readNotes();
    lis.forEach(function (li) {
      var n = notes[li.getAttribute('data-note-slug')];
      if (!n || !n.t) return;
      var p = document.createElement('p');
      p.className = 'mt-1.5 whitespace-pre-wrap text-[13px] leading-relaxed text-brand-700';
      p.textContent = '我的笔记：' + n.t;
      li.appendChild(p);
    });
  }

  /* 每周模考落地页「我的模考战绩」卡：tiku-hist 按周聚合历史得分（+tiku-rank 名次），纯本地 */
  function initWeeklyHistory() {
    var rankEl = document.getElementById('my-rank'); if (!rankEl) return;
    var key = rankEl.getAttribute('data-rank-key') || '';
    if (key.indexOf('weekly:') !== 0) return;
    var slug = key.split(':')[1] || '';
    var anchor = document.querySelector('section[aria-labelledby="wk-top-h"]');
    /* SSR 骨架 #wk-mine 由内联 WK_MINE_JS 首帧同步填行（layout.ts）；已有行则不重建，骨架空着（内联脚本未跑）才兜底填 */
    var ssr = document.getElementById('wk-mine');
    if (ssr && ssr.querySelector('li')) return;
    if (!ssr && (!anchor || !anchor.parentNode)) return;
    var start = document.getElementById('mock-start');
    var lineName = (start && (start.getAttribute('data-mock-s') || '').split(' · ')[0]) || '';
    if (!lineName) return;
    var hist = store.read('tiku-hist', '[]');
    if (!Array.isArray(hist)) return;
    var rk = store.read('tiku-rank', '{}');
    var byWeek = {};
    hist.forEach(function (h) {
      if (!h || !h.n || typeof h.s !== 'string') return;
      var m = /^(.+) · 每周模考（(\d{4}-W\d{2})）$/.exec(h.s);
      if (!m || m[1] !== lineName) return;
      if (!(m[2] in byWeek)) byWeek[m[2]] = h; /* hist 新在前：取该周最新一次 */
    });
    var weeks = Object.keys(byWeek).sort().reverse().slice(0, 8);
    if (weeks.length === 0) return;
    var cur = (ssr && ssr.getAttribute('data-wk')) || curWeekIso();
    var sec = ssr || document.createElement('section');
    var ol = ssr && ssr.querySelector('ol');
    if (!ssr) {
      sec.id = 'wk-mine';
      sec.className = 'mt-8';
      sec.setAttribute('aria-labelledby', 'wk-mine-h');
      var h2 = document.createElement('h2');
      h2.id = 'wk-mine-h';
      h2.className = 'mb-3 text-lg font-semibold md:text-xl';
      h2.textContent = '我的模考战绩';
      sec.appendChild(h2);
    }
    if (!ol) {
      ol = document.createElement('ol');
      ol.className = 'divide-y divide-slate-100 rounded-2xl border border-slate-200 bg-white';
      sec.appendChild(ol);
    }
    weeks.forEach(function (w, i) {
      var h = byWeek[w];
      var pct = Math.round(h.ok / h.n * 100);
      var li = document.createElement('li');
      li.className = 'flex flex-wrap items-center gap-x-3 gap-y-1 px-4 py-3 text-sm';
      var sw = document.createElement('span');
      sw.className = 'font-medium tabular-nums';
      sw.textContent = w;
      li.appendChild(sw);
      if (w === cur) {
        var tb = document.createElement('span');
        tb.className = 'rounded-full bg-amber-100 px-2 py-0.5 text-[12px] font-medium text-amber-800';
        tb.textContent = '本周';
        li.appendChild(tb);
      }
      var sc = document.createElement('span');
      sc.className = 'text-slate-600';
      sc.textContent = pct + ' 分（' + h.ok + '/' + h.n + '）';
      li.appendChild(sc);
      var v = rk['weekly:' + slug + ':' + w];
      if (v && typeof v.r === 'number') {
        var rb = document.createElement('span');
        rb.className = 'text-slate-500';
        rb.textContent = '第 ' + v.r + ' 名';
        li.appendChild(rb);
      }
      var prev = byWeek[weeks[i + 1]];
      if (i === 0 && prev) {
        var d = pct - Math.round(prev.ok / prev.n * 100);
        if (d !== 0) {
          var db = document.createElement('span');
          db.className = d > 0 ? 'font-medium text-emerald-700' : 'font-medium text-rose-600';
          db.textContent = '较上次 ' + (d > 0 ? '+' : '') + d + ' 分';
          li.appendChild(db);
        }
      }
      ol.appendChild(li);
    });
    if (ssr) { sec.hidden = false; return; }
    anchor.parentNode.insertBefore(sec, anchor.nextSibling);
  }

  /* bfcache 恢复：脚本不重跑、DOM 停在离开时的快照，题页作答后原生 Back 回列表/首页/考点页，已做徽标、工具条、进度卡等
     本机 localStorage 驱动的水化态全部过期。离开（pagehide）时记 tiku-* 指纹，恢复（pageshow.persisted）且指纹变了才 reload
     ——与 F5 同路径一次拿到全部 init 的正确结果；没变则保留 bfcache 秒回。html[data-bfr] 告知 vitals.js 本次恢复不计 PV。
     题页只浏览不作答也必写 tiku-view / tiku-last：这两个键在本页没有消费者元素（首页续练 / 最近浏览、/my/ 最近浏览）时
     不进指纹，恢复后只重跑幂等的消费者（底栏「练习」href、本题 tiku-last / tiku-view 记忆）而不 reload */
  var BF_SOFT_KEYS = { 'tiku-view': ['rview-card', 'view-sec'], 'tiku-last': ['home-continue'] };
  function bfSoftKey(k) {
    var ids = BF_SOFT_KEYS[k];
    if (!ids) return false;
    for (var i = 0; i < ids.length; i++) if (document.getElementById(ids[i])) return false;
    return true;
  }
  function initBfcacheRefresh() {
    var snap = '';
    function fp() {
      var ks = [];
      try {
        for (var i = 0; i < localStorage.length; i++) { var k = localStorage.key(i); if (k && k.indexOf('tiku-') === 0 && !bfSoftKey(k)) ks.push(k); }
      } catch (_) { return ''; }
      ks.sort();
      var s = '#';
      for (var j = 0; j < ks.length; j++) {
        var v = '', h = 5381;
        try { v = localStorage.getItem(ks[j]) || ''; } catch (_) { /* noop */ }
        for (var c = 0; c < v.length; c++) h = ((h * 33) ^ v.charCodeAt(c)) >>> 0;
        s += ks[j] + '=' + v.length + ':' + h + ';';
      }
      return s;
    }
    addEventListener('pagehide', function () { snap = fp(); });
    addEventListener('pageshow', function (e) {
      if (!e.persisted || !snap) return;
      if (fp() !== snap) {
        document.documentElement.dataset.bfr = '1';
        location.reload();
        return;
      }
      writeLastQ();
      recordView();
      initTabPractice();
    });
  }

  /* 题页材料盒（R634）：max-h-72 折叠 + 触屏 / macOS 无常驻滚动条，生产 34 篇材料 375 下 32 篇溢出（中位 245px）、15 篇表格整个落在盒底之下，
     读者不知道盒内还有内容。溢出且未滚到底时挂 qz-mat-ovf（盒底渐隐，滚到底撤）并显示「展开材料全文」；展开挂 qz-mat-open 撤 max-height；
     选择记 sessionStorage tiku-mat-open，同篇兄弟题 / 后续材料题沿用；不溢出的材料不出按钮（practice.js matMore 同契约） */
  function initQMaterial() {
    var box = document.getElementById('q-material'); var btn = document.getElementById('q-mat-more');
    if (!box || !btn) return;
    if (box.scrollHeight <= box.clientHeight + 4) return;
    var open = false;
    try { open = sessionStorage.getItem('tiku-mat-open') === '1'; } catch (_) { /* 无存储 */ }
    function fade() { box.classList.toggle('qz-mat-ovf', !open && box.scrollTop + box.clientHeight < box.scrollHeight - 4); }
    function apply() {
      box.classList.toggle('qz-mat-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? '收起材料 ↑' : '展开材料全文 ↓';
      fade();
    }
    btn.hidden = false;
    btn.addEventListener('click', function () {
      open = !open;
      try { sessionStorage.setItem('tiku-mat-open', open ? '1' : '0'); } catch (_) { /* 无存储 */ }
      apply();
      /* 收起后若盒顶已在视口之上，滚回盒顶（顶栏 56px 下），免得按钮连同题干一起跳走 */
      var top = box.getBoundingClientRect().top;
      if (!open && top < 64) window.scrollTo({ top: window.scrollY + top - 64 });
    });
    box.addEventListener('scroll', fade, { passive: true });
    apply();
  }

  /* 材料内宽表横滚可发现性（R672，practice.js matTblFade 同契约）：<640 表头 min-width 下 4–5 列表 320–414 必横滚而触屏无常驻滚动条，
     可横滚且未滚到右端时包裹层挂 qz-tbl-ovf（右缘渐隐，滚到右端撤）；宽度变化（视口 / 展开材料）ResizeObserver 重算，无 RO 退回 resize */
  function matTblFade(root) {
    Array.prototype.slice.call(root.querySelectorAll('.qz-tbl')).forEach(function (w) {
      var mark = function () { w.classList.toggle('qz-tbl-ovf', w.scrollLeft + w.clientWidth < w.scrollWidth - 2); };
      w.addEventListener('scroll', mark, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(mark).observe(w); else window.addEventListener('resize', mark);
      mark();
    });
  }
  function initMatTables() {
    var box = document.getElementById('q-material');
    if (box) matTblFade(box);
  }

  /* 题页字号三档：#q-font 循环 标准/大/特大，切 <html> 的 ws-font-1/2，偏好存 tiku-font（与操作台同键同值）；首帧预挂载在 layout BOOT_JS，档名由 CSS ::after 出 */
  function initQFont() {
    var btn = document.getElementById('q-font');
    if (!btn) return;
    var lv = store.read('tiku-font', 'null');
    if (lv !== 1 && lv !== 2) lv = 0;
    var names = ['标准', '大', '特大'];
    function apply() {
      document.documentElement.classList.toggle('ws-font-1', lv === 1);
      document.documentElement.classList.toggle('ws-font-2', lv === 2);
      btn.setAttribute('aria-label', '切换字号，当前' + names[lv]);
    }
    btn.addEventListener('click', function () {
      lv = (lv + 1) % 3;
      store.write('tiku-font', lv);
      apply();
    });
    apply();
  }

  /* 题页触屏左右滑动切题（与操作台 ws-qcard 同阈值：横向 ≥60px 且 >2× 纵向、有文本选中不切）：只认题干 / 选项 / 判定区起手，
     与 ←→ 键同一套考点顺序（#q-nav data-prev/next），首末题无目标则不动（底栏 #nav-next 末题是「返回列表」，不接）；
     长按排除的 pointermove >10px 已自行取消，滑动不会误排除 */
  function initQSwipe() {
    var nav = document.getElementById('q-nav');
    if (!nav) return;
    var dp = nav.getAttribute('data-prev'); var dn = nav.getAttribute('data-next');
    var prevHref = dp ? '/q/' + dp + '/' : ''; var nextHref = dn ? '/q/' + dn + '/' : '';
    var sx = 0, sy = 0, tracking = false;
    function zone(t) { return t && t.closest && t.closest('#stem, #options, #verdict, #hint-box, #st-row'); }
    document.addEventListener('touchstart', function (e) {
      tracking = e.touches.length === 1 && !!zone(e.target);
      if (!tracking) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (!tracking || e.changedTouches.length !== 1) { tracking = false; return; }
      tracking = false;
      var sel = window.getSelection && window.getSelection();
      if (sel && String(sel).length > 0) return;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) < 60 || Math.abs(dx) <= 2 * Math.abs(dy)) return;
      var href = dx < 0 ? qqStepHref(1, nextHref) : qqStepHref(-1, prevHref);
      if (href) location.href = href;
    }, { passive: true });
  }

  /* 全站夜间模式：顶栏 ☾/☀ 切换 <html> 的 ws-dark，偏好存 tiku-dark，与操作台互通；首屏预挂载在 layout 内联脚本 */
  function initSiteDark() {
    var btn = document.getElementById('site-dark');
    if (!btn) return;
    var pref = store.read('tiku-dark', 'null');
    var on = pref === 1 || (pref !== 0 && matchMedia('(prefers-color-scheme: dark)').matches);
    function apply() {
      document.documentElement.classList.toggle('ws-dark', on);
      btn.textContent = on ? '☀︎' : '☾';
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    btn.addEventListener('click', function () {
      on = !on;
      store.write('tiku-dark', on ? 1 : 0);
      apply();
    });
    apply();
  }

  /* tiku-hist 按卷名（h.s）聚合：最高百分制与应考次数 */
  function histBest(cnt) {
    var hist = store.read('tiku-hist', '[]');
    if (!Array.isArray(hist)) hist = [];
    var best = {};
    hist.forEach(function (h) {
      if (!h || !h.n || !h.s) return;
      var pct = Math.round(h.ok / h.n * 100);
      if (!(h.s in best) || pct > best[h.s]) best[h.s] = pct;
      if (cnt) cnt[h.s] = (cnt[h.s] || 0) + 1;
    });
    return best;
  }

  /* /mock/ 索引固定卷成绩点亮：用 tiku-hist 按卷名匹配「最高 X 分」，记录不上传；开始页 CTA #mock-start 不加（成绩由 #my-rank pill 首帧直出，往 CTA 内追加在 375 会折行） */
  function initMockScores() {
    var links = document.querySelectorAll('[data-mock-s]:not(#mock-start)');
    if (links.length === 0) return;
    var cnt = {};
    var best = histBest(cnt);
    Array.prototype.forEach.call(links, function (a) {
      var s = a.getAttribute('data-mock-s');
      if (!(s in best)) return;
      var b = document.createElement('span');
      b.className = 'ml-1.5 rounded bg-emerald-50 px-1.5 py-0.5 text-xs font-medium text-emerald-700';
      b.textContent = '最高 ' + best[s] + ' 分';
      a.appendChild(b);
      a.setAttribute('title', '已考 ' + cnt[s] + ' 次 · 最高 ' + best[s] + ' 分');
    });
  }

  /* 随机组卷题数选择（科目页，偏好存 tiku-n）；智能练习（practice.js mode=smart 客户端选题）同步题数 */
  function initPaperN() {
    var sel = document.getElementById('paper-n');
    var link = document.getElementById('custom-paper');
    var smart = document.getElementById('smart-paper');
    if (!sel || !link) return;
    function apply(n) {
      link.setAttribute('href', link.getAttribute('href').replace(/([?&]n=)\d+/, '$1' + n));
      link.textContent = '随机组卷 ' + n + ' 题 →';
      if (smart) smart.setAttribute('href', smart.getAttribute('href').replace(/([?&]n=)\d+/, '$1' + n));
    }
    var saved = store.read('tiku-n', '10');
    if ([5, 10, 15, 20].indexOf(saved) < 0) saved = 10;
    sel.value = String(saved);
    if (saved !== 10) apply(saved);
    sel.addEventListener('change', function () {
      var n = parseInt(sel.value, 10);
      store.write('tiku-n', n);
      apply(n);
    });
  }

  /* ---------- 考试线记忆贯通每日一练入口 ---------- */
  /* 首页 hero 与练习台宫格入口改写为本线直达；宫格副标由 SSR 每线 span + html[data-exam] CSS 选显，此处不改字。载入与切 tab（tiku:exam）各跑一次，切线后入口跟随 */
  function applyExamLinks(slug) {
    if (typeof slug !== 'string' || !/^[\w-]+$/.test(slug)) return;
    if (!document.querySelector('.js-exam-tab[data-exam="' + slug + '"]')) return;
    var q = encodeURIComponent(slug);
    var hero = document.getElementById('hero-daily');
    if (hero) hero.href = '/daily/?exam=' + q;
    var qd = document.getElementById('quick-daily');
    if (qd) qd.href = '/practice/?mode=daily&exam=' + q;
    var hm = document.getElementById('hero-mock');
    if (hm) hm.href = '/mock/?exam=' + q;
    var hw = document.getElementById('hero-weekly');
    if (hw) {
      if (!hw.dataset.weeklyHref) hw.dataset.weeklyHref = hw.getAttribute('href') || '';
      hw.href = (hw.dataset.weekly || '').split(',').indexOf(slug) !== -1 ? '/mock/' + q + '/?paper=w' : hw.dataset.weeklyHref;
    }
    var qm = document.getElementById('quick-mock');
    if (qm) qm.href = '/mock/?exam=' + q;
  }
  function initDailyEntryMemory() {
    document.addEventListener('tiku:exam', function () { applyExamLinks(document.documentElement.dataset.exam); });
    var saved = store.read('tiku-exam', 'null');
    if (typeof saved !== 'string' || !/^[\w-]+$/.test(saved)) return;
    applyExamLinks(saved);
    /* /daily/ 无参数页：提示直达本线卷（chips 中存在该线才显示） */
    var hint = document.getElementById('daily-hint');
    var hintA = document.getElementById('daily-hint-a');
    if (hint && hintA && !/[?&]exam=/.test(location.search)) {
      var chip = document.querySelector('nav[aria-label="按考试线出题"] a[href*="exam=' + saved + '"]');
      if (chip) {
        hintA.href = chip.getAttribute('href');
        hintA.textContent = chip.textContent;
        hint.hidden = false;
        hint.classList.remove('hidden');
      } else {
        hint.hidden = true;
      }
    }
  }

  initQuiz();
  initQSide();
  initSheet();
  initDaily();
  initStreak();
  initDailyStat();
  initMyRank();
  initNick();
  /* /my/ 专属逻辑在 public/my.js（仅 /my/ 页加载、defer 排在 app.js 之前，见 layout.ts）：以闭包共享工具实例化后按原顺序调用 */
  var myMod = window.__tikuMy ? window.__tikuMy({ store: store, localDay: localDay, toSlug: toSlug, shuffleSlugs: shuffleSlugs, QTYPE: QTYPE, wrongDue: wrongDue, readNotes: readNotes, WEAK_MIN_DONE: WEAK_MIN_DONE, WEAK_ACC: WEAK_ACC, stars: stars, bindNote: bindNote, saveNote: saveNote, smartPracticeHref: smartPracticeHref, weeklyMockDone: weeklyMockDone, dailyDoneToday: dailyDoneToday, planQuotaHref: planQuotaHref, planMoreHref: planMoreHref, curWeekIso: curWeekIso, showNavChip: showNavChip, NOTE_KEY: NOTE_KEY, capNotes: capNotes, FBK_LABEL: FBK_LABEL }) : null;
  if (myMod) { myMod.initMy(); myMod.initStudyPlan(); myMod.initZaSync(); myMod.initDataPort(); }
  initMockResult();
  initHome();
  initWeakSpot();
  initTabPractice();
  initExamTabs();
  initOnboard();
  initRowDone();
  initKpProgress();
  initKpPageCard();
  initQStatus();
  recordView();
  initRecentView();
  initMyAi();
  initMyFbk();
  initKpFollow();
  initHomeKpFav();
  initHomeRecentView();
  initKpFavList();
  initQShare();
  initQMaterial();
  initQFont();
  initQSwipe();
  initQSimilar();
  initQNav();
  initActEol();
  initMatTables();
  initAiAsk();
  initTodayGoal();
  initCountdown();
  initNote();
  initPaperN();
  initDailyHistory();
  initMockExamFilter();
  initMockScores();
  initDailyEntryMemory();
  initSiteDark();
  initBfcacheRefresh();
  initReplyDot();
  initDueBadge();
  initDailyDot();
  initMockDot();
  initWeeklyHistory();
  initCrumbTap();
  initPrintNotes();
  /* 打印页「打印 / 保存为 PDF」按钮（CSP 不允许内联处理器） */
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.js-print')) window.print();
  });
  initSearchHist();
  initSearchSuggest();
  /* /my/ 页内锚点：上方区块（统计/勋章/错题卡片/掌握度）在同步水化与 /api/questions 异步返回后才长高，
     浏览器按首帧文档滚到的锚点会被推偏，且长高全计入 CLS。BOOT_JS（layout.ts）已在首帧前把 hash 存入
     html[data-anchor]、去掉片段让浏览器不滚并 visibility:hidden 压住首帧；此处（同步水化完成后）恢复 hash、
     一次滚到位再显示——首个可见帧已是滚好的文档，不产生位移记录。之后 3 秒内：锚点所在顶层区块之前的兄弟区块
     置 overflow-anchor:none，让浏览器原生滚动锚定把锚点节点选在目标区块内，上方异步长高由锚定同帧补偿且不计 CLS
     （ResizeObserver 补偿是下一帧才生效、仍计 CLS，只作无锚定浏览器兜底）；用户一旦滚动/按键即停 */
  var anchorId = document.documentElement.dataset.anchor || ((location.pathname === '/my/' || /^#kp-/.test(location.hash)) && location.hash.length > 1 ? decodeURIComponent(location.hash.slice(1)) : '');
  if (anchorId) {
    var anchorEl = document.getElementById(anchorId);
    /* 科目页 #kp-<根 slug>：频道页/首页模块卡「考点索引」落到根考点折叠区，details 自身为锚点时浏览器不自动展开，在隐藏态展开后再定位 */
    if (anchorEl && anchorEl.tagName === 'DETAILS') anchorEl.open = true;
    if (document.documentElement.dataset.anchor) {
      delete document.documentElement.dataset.anchor;
      try { history.replaceState(null, '', location.pathname + location.search + '#' + anchorId); } catch (_) { /* noop */ }
      /* 先在隐藏态定位，等初始化发起的列表填充（错题卡/掌握度等锚点下方内容）回来再显示；上限 1200ms */
      var anchorShow = function () { document.documentElement.style.visibility = ''; };
      var anchorWait = myMod && myMod.fillsSettled ? myMod.fillsSettled() : Promise.resolve();
      Promise.race([anchorWait, new Promise(function (res) { setTimeout(res, 1200); })]).then(anchorShow, anchorShow);
    }
    if (anchorEl && 'ResizeObserver' in window) {
      var anchorSec = anchorEl;
      while (anchorSec.parentElement && anchorSec.parentElement.tagName !== 'MAIN' && anchorSec.parentElement !== document.body) anchorSec = anchorSec.parentElement;
      var anchorPinned = [];
      for (var sib = anchorSec.previousElementSibling; sib; sib = sib.previousElementSibling) { sib.style.overflowAnchor = 'none'; anchorPinned.push(sib); }
      anchorEl.scrollIntoView();
      var anchorRo = new ResizeObserver(function () { anchorEl.scrollIntoView(); });
      var stopAnchor = function () {
        anchorRo.disconnect();
        anchorPinned.forEach(function (el) { el.style.overflowAnchor = ''; });
        anchorPinned = [];
      };
      ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (ev) { addEventListener(ev, stopAnchor, { once: true, passive: true }); });
      anchorRo.observe(document.body);
      setTimeout(stopAnchor, 3000);
    } else if (anchorEl) {
      requestAnimationFrame(function () { anchorEl.scrollIntoView(); });
    }
  }
  /* /my/ 刷新 / 回退滚动位置恢复（docs/plan-r602）：pagehide 时把 scrollY 存 sessionStorage 供 BOOT_JS 判定；
     BOOT 已关掉原生首帧滚动并用 visibility:hidden 压住首帧、把位置放在 html[data-restore-y]。此处（同步水化完成后）
     隐藏态先滚回原位，等初始化发起的列表填充（错题卡 / 掌握度等异步长高）回来再滚一次并显示——首个可见帧就是列表已就位、
     滚到原位的文档，不产生位移记录；上限 1200ms 与锚点直达同口径 */
  if (location.pathname === '/my/') {
    addEventListener('pagehide', function () {
      try { sessionStorage.setItem('tiku-my-y', String(Math.round(window.scrollY))); } catch (_) { /* noop */ }
    });
    var restoreY = Math.round(+document.documentElement.dataset.restoreY);
    if (restoreY > 0) {
      delete document.documentElement.dataset.restoreY;
      window.scrollTo(0, restoreY);
      var restoreShow = function () { window.scrollTo(0, restoreY); document.documentElement.style.visibility = ''; };
      var restoreWait = myMod && myMod.fillsSettled ? myMod.fillsSettled() : Promise.resolve();
      Promise.race([restoreWait, new Promise(function (res) { setTimeout(res, 1200); })]).then(restoreShow, restoreShow);
    }
  }
  /* 离线兜底与静态资产缓存（public/sw.js：导航 network-first，HTML 不缓存） */
  if ('serviceWorker' in navigator) navigator.serviceWorker.register('/sw.js').catch(function () { /* noop */ });
})();
